"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClothingAgeClassification = exports.ClassificationType = exports.ClassificationPlatform = exports.ClassificationErrorCode = exports.ClassificationDecision = exports.CheckoutUrlType = exports.CheckoutShippingMethodPromptBehavior = exports.CheckoutRedirectMethod = exports.CheckoutPromptBehavior = exports.CheckoutErrorCode = exports.CheckoutAssetType = exports.ChargebackProcessStatus = exports.ChargebackPaymentStatus = exports.ChargeInputType = exports.ChargeEstimateSource = exports.ChannelTransactionType = exports.ChannelOrderFulfillmentStatusCode = exports.ChannelOrderAcceptanceStatus = exports.ChannelOrderAcceptanceRejectionReason = exports.ChannelOrderAcceptanceNextActionFrom = exports.ChannelOrderAcceptanceFailureReasonCode = exports.ChannelOrderAcceptanceErrorAction = exports.ChannelBilledTransactionType = exports.CatalogImportType = exports.CarrierValidationStatus = exports.CarrierLabelGenerationMethod = exports.CarrierFileType = exports.CarrierChargeType = exports.CarrierChargeTransactionType = exports.CalculatorEngine = exports.BrowserBundleErrorCode = exports.BillingTransactionType = exports.BillingTransactionStatus = exports.BillingStatementAttachmentKey = exports.BillingMetricKey = exports.BillingAllocationKey = exports.BankPaymentStatusCode = exports.BankPaymentPromiseCompletedMethod = exports.BankAccountStatus = exports.AutoRestrictRule = exports.ApiCallReferenceId = exports.AnyDangerousGoods = exports.AnshItemType = exports.AldoItemType = exports.AdyenIntegrationType = exports.AdjustmentTransactionType = exports.AddressConfigurationSettingProvinceCode = exports.AccountType = exports.AccountSettingLiabilitiesMethod = exports.AccountPaymentHoldReason = void 0;
exports.GoogleAnalyticsPlugin = exports.FtpProtocol = exports.FtpIntent = exports.FraudReviewResponsibleParty = exports.FraudProviderStatus = exports.FraudProvider = exports.Format = exports.FlowApp = exports.FinancialReportingResponsibleParty = exports.FeesSource = exports.FeatureType = exports.FeatureStatus = exports.FeatureScope = exports.ExportContentType = exports.ExperienceOrderActionTrigger = exports.ExperienceOrderAction = exports.ExperienceImportType = exports.EventType = exports.ErpFileType = exports.EmptyAttribute = exports.DutyTransactionType = exports.DutySimpleExpressionType = exports.DutySelectionRule = exports.DutyRateUnitOfMeasure = exports.DutyRateSource = exports.DutyExemptItemTypes = exports.DutyCompoundExpressionType = exports.DisputeType = exports.DisputeTransactionType = exports.DisputeStatus = exports.DisputeReportingCategory = exports.DisputeProcessor = exports.DisputeLiability = exports.DisputeImportType = exports.DisputeImportStatus = exports.DisputeEvidence = exports.DisputeDefenseOutcome = exports.DisputeCategory = exports.DisputeBillable = exports.DiscountRequestOrderEntitlementKey = exports.DeminimisAdjustmentType = exports.DeliveredDutyOptionMessageType = exports.DebugAccountingTransactionType = exports.CrossdockTrackingStatus = exports.ContentTypeCast = exports.ContentType = exports.ContentStatus = exports.ContentElementType = exports.ComplianceType = exports.Company = void 0;
exports.Owner = exports.OutputStyle = exports.OrganizationRestrictionScreeningStatus = exports.OrganizationRestrictionRiskLevel = exports.OrganizationRestrictionReviewType = exports.OrganizationRestrictionNoteType = exports.OrganizationRestrictionApprovalStatus = exports.OrganizationPaymentStatus = exports.OrganizationMetricType = exports.OrganizationCapability = exports.OrderValidationStatus = exports.OrderTransactionType = exports.OrderLifecycleEvent = exports.OrderChargeTrigger = exports.OrderCancellationInitiatedBy = exports.OrderAttributeIntent = exports.OrderAddressValidationStatus = exports.OrderAction = exports.OnboardingStateSource = exports.OnboardingAutomationTaskState = exports.OnboardingAutomationProcessState = exports.OnboardingAuditThemeKey = exports.OnboardingAuditResult = exports.OnboardingAuditMessageLevel = exports.NoLiabilityReasonCode = exports.NatureOfSale = exports.MixedBagWeight = exports.ManualTransactionCategory = exports.ManualReviewRuleStatus = exports.LogisticsPayoutResolutionMethod = exports.LogisticsCapability = exports.LiabilityType = exports.LabelTransactionType = exports.LabelRequestResultState = exports.LabelRequestResultOrganizationType = exports.LabelRequestErrorHandlingResponsibility = exports.LabelEventSource = exports.LabelEventMedium = exports.LabelCreationStatus = exports.LabelCancellationErrorCode = exports.LabelBillingStrategy = exports.KeywordType = exports.ItemType = exports.ItemQuantityAction = exports.ItemHarmonizationStatus = exports.ItemClassificationStatus = exports.ItemClassificationAction = exports.HttpMethod = exports.HarmonizationDecisionSource = exports.GraphqlServiceTypes = void 0;
exports.SnoozeNextActionWith = exports.SimpleRoundingStrategy = exports.ShopifyService = exports.ShopifyPromotionStatus = exports.ShopifyPromotionOrderEntitlementComponent = exports.ShopifyPromotionOfferAllocationMethod = exports.ShopifyPromotionBehavior = exports.ShopifyMonitoringTrackingField = exports.ShopifyMonitoringMonitorReviewStatus = exports.ShopifyMarketsTradeSector = exports.ShopifyMarketsQueuedRecordType = exports.ShopifyMarketsHtsNumberAvailable = exports.ShopifyMarketsDangerousGoods = exports.ShopifyIncotermConfiguration = exports.ShopifyGrantStatus = exports.ShopifyCheckInventoryErrorCode = exports.SessionCountryStatus = exports.RiskEvaluation = exports.RiskCheck = exports.RevenueRecordType = exports.RestrictionStatus = exports.RestrictionDecision = exports.RestrictionAction = exports.ResponsibleParty = exports.ReportingScheme = exports.ReportingFulfillmentIsVirtual = exports.ReportType = exports.ReportStatus = exports.ReportPaymentType = exports.ReportInterval = exports.RejectionReason = exports.RedirectReason = exports.ReboundConfigurationStatus = exports.RateSource = exports.RateLevelKey = exports.QuoteRequestType = exports.PromptTarget = exports.PromptOptions = exports.PromptCheckoutDisplayPosition = exports.PromptAction = exports.ProductStatus = exports.ProcessorEntityStatus = exports.Processor = exports.ProcessingTransactionType = exports.PriceSelector = exports.PreferredBillingSchedule = exports.PaymentTerm = exports.PaymentSummaryType = exports.PaymentSummaryStatus = exports.PaymentShortUrlDiscriminator = void 0;
exports.UnclassifiedProductStatus = exports.TrueupTransactionType = exports.TransferMethod = exports.TransactionPostingMethod = exports.TrackingProcessingFailureClassification = exports.TrackingLabelDimensionsSource = exports.TrackingIntegrationType = exports.TaxTransactionType = exports.TaxParty = exports.TaxCalculationErrorCode = exports.TaxAndDutyInclusivitySetting = exports.TaskProcessorKey = exports.TariffEligibilityType = exports.SuggestionAction = exports.SubscriptionFrequency = exports.StatisticType = exports.StatementTransferTransactionLocation = exports.StatementStatus = exports.SourceTypeFilter = exports.SnoozeSourceType = void 0;
var AccountPaymentHoldReason;
(function (AccountPaymentHoldReason) {
    AccountPaymentHoldReason["FRAUDULENT"] = "fraudulent";
    AccountPaymentHoldReason["FROZEN"] = "frozen";
    AccountPaymentHoldReason["INVALID_BANK_ACCOUNT"] = "invalid_bank_account";
})(AccountPaymentHoldReason = exports.AccountPaymentHoldReason || (exports.AccountPaymentHoldReason = {}));
var AccountSettingLiabilitiesMethod;
(function (AccountSettingLiabilitiesMethod) {
    AccountSettingLiabilitiesMethod["WITHHOLDING"] = "withholding";
    AccountSettingLiabilitiesMethod["TRANSACTION"] = "transaction";
})(AccountSettingLiabilitiesMethod = exports.AccountSettingLiabilitiesMethod || (exports.AccountSettingLiabilitiesMethod = {}));
var AccountType;
(function (AccountType) {
    AccountType["CHANNEL"] = "channel";
    AccountType["ORGANIZATION"] = "organization";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AddressConfigurationSettingProvinceCode;
(function (AddressConfigurationSettingProvinceCode) {
    AddressConfigurationSettingProvinceCode["ISO_3166_2"] = "iso_3166_2";
    AddressConfigurationSettingProvinceCode["NAME"] = "name";
})(AddressConfigurationSettingProvinceCode = exports.AddressConfigurationSettingProvinceCode || (exports.AddressConfigurationSettingProvinceCode = {}));
var AdjustmentTransactionType;
(function (AdjustmentTransactionType) {
    AdjustmentTransactionType["ADJUSTMENT"] = "adjustment";
    AdjustmentTransactionType["REVERSAL"] = "reversal";
})(AdjustmentTransactionType = exports.AdjustmentTransactionType || (exports.AdjustmentTransactionType = {}));
var AdyenIntegrationType;
(function (AdyenIntegrationType) {
    AdyenIntegrationType["HOSTED_PAYMENT_PAGE"] = "hosted_payment_page";
    AdyenIntegrationType["CHECKOUT_PAYMENTS_API"] = "checkout_payments_api";
    AdyenIntegrationType["CLASSIC_AUTHORISE_API"] = "classic_authorise_api";
})(AdyenIntegrationType = exports.AdyenIntegrationType || (exports.AdyenIntegrationType = {}));
var AldoItemType;
(function (AldoItemType) {
    AldoItemType["PHYSICAL"] = "physical";
    AldoItemType["DIGITAL"] = "digital";
})(AldoItemType = exports.AldoItemType || (exports.AldoItemType = {}));
var AnshItemType;
(function (AnshItemType) {
    AnshItemType["PHYSICAL"] = "physical";
    AnshItemType["DIGITAL"] = "digital";
})(AnshItemType = exports.AnshItemType || (exports.AnshItemType = {}));
var AnyDangerousGoods;
(function (AnyDangerousGoods) {
    AnyDangerousGoods["YES"] = "yes";
    AnyDangerousGoods["NO"] = "no";
    AnyDangerousGoods["I_DONT_KNOW"] = "i_dont_know";
})(AnyDangerousGoods = exports.AnyDangerousGoods || (exports.AnyDangerousGoods = {}));
var ApiCallReferenceId;
(function (ApiCallReferenceId) {
    ApiCallReferenceId["DUTY_RATES_DATA_EVENT"] = "duty_rates_data_event";
    ApiCallReferenceId["INTEGRATION_TEST"] = "integration_test";
    ApiCallReferenceId["UNIT_TEST"] = "unit_test";
})(ApiCallReferenceId = exports.ApiCallReferenceId || (exports.ApiCallReferenceId = {}));
var AutoRestrictRule;
(function (AutoRestrictRule) {
    AutoRestrictRule["DG_HAZMAT"] = "prr-3ce7d556f2464314ab0a3e8eee33e0ce";
    AutoRestrictRule["DG_BATTERIES"] = "prr-599c6246a1a24752aeb85e8f79030781";
    AutoRestrictRule["WEAPON"] = "prr-79e41878ea564f9c81cc432a0e84703f";
    AutoRestrictRule["DRUGS"] = "prr-f29c26dc09e04536bc77f9c32786ed70";
    AutoRestrictRule["KNIVES"] = "prr-b186129720f0446eb452a68518437c95";
})(AutoRestrictRule = exports.AutoRestrictRule || (exports.AutoRestrictRule = {}));
var BankAccountStatus;
(function (BankAccountStatus) {
    BankAccountStatus["ON_HOLD"] = "on_hold";
    BankAccountStatus["NOT_ON_HOLD"] = "not_on_hold";
})(BankAccountStatus = exports.BankAccountStatus || (exports.BankAccountStatus = {}));
var BankPaymentPromiseCompletedMethod;
(function (BankPaymentPromiseCompletedMethod) {
    BankPaymentPromiseCompletedMethod["CREDIT"] = "credit";
    BankPaymentPromiseCompletedMethod["TIME"] = "time";
})(BankPaymentPromiseCompletedMethod = exports.BankPaymentPromiseCompletedMethod || (exports.BankPaymentPromiseCompletedMethod = {}));
var BankPaymentStatusCode;
(function (BankPaymentStatusCode) {
    BankPaymentStatusCode["SCHEDULED"] = "scheduled";
    BankPaymentStatusCode["SENT"] = "sent";
    BankPaymentStatusCode["FAILED"] = "failed";
})(BankPaymentStatusCode = exports.BankPaymentStatusCode || (exports.BankPaymentStatusCode = {}));
var BillingAllocationKey;
(function (BillingAllocationKey) {
    BillingAllocationKey["FREIGHT_COST"] = "freight_cost";
    BillingAllocationKey["ADJUSTMENT"] = "adjustment";
    BillingAllocationKey["VAT_DEMINIMIS"] = "vat_deminimis";
    BillingAllocationKey["DUTY_DEMINIMIS"] = "duty_deminimis";
    BillingAllocationKey["DUTIES_ITEM_PRICE"] = "duties_item_price";
    BillingAllocationKey["DUTIES_FREIGHT"] = "duties_freight";
    BillingAllocationKey["DUTIES_INSURANCE"] = "duties_insurance";
    BillingAllocationKey["VAT_ITEM_PRICE"] = "vat_item_price";
    BillingAllocationKey["VAT_FREIGHT"] = "vat_freight";
    BillingAllocationKey["VAT_INSURANCE"] = "vat_insurance";
    BillingAllocationKey["VAT_DUTIES_ITEM_PRICE"] = "vat_duties_item_price";
    BillingAllocationKey["VAT_DUTIES_FREIGHT"] = "vat_duties_freight";
    BillingAllocationKey["VAT_DUTIES_INSURANCE"] = "vat_duties_insurance";
    BillingAllocationKey["ITEM_PRICE"] = "item_price";
    BillingAllocationKey["ITEM_DISCOUNT"] = "item_discount";
    BillingAllocationKey["ROUNDING"] = "rounding";
    BillingAllocationKey["INSURANCE"] = "insurance";
    BillingAllocationKey["SHIPPING"] = "shipping";
    BillingAllocationKey["ORDER_DISCOUNT"] = "order_discount";
    BillingAllocationKey["SUBTOTAL_PERCENT_SALES_MARGIN"] = "subtotal_percent_sales_margin";
    BillingAllocationKey["SUBTOTAL_VAT_PERCENT_SALES_MARGIN"] = "subtotal_vat_percent_sales_margin";
    BillingAllocationKey["SUBTOTAL_DUTY_PERCENT_SALES_MARGIN"] = "subtotal_duty_percent_sales_margin";
    BillingAllocationKey["VAT_SUBSIDY"] = "vat_subsidy";
    BillingAllocationKey["DUTY_SUBSIDY"] = "duty_subsidy";
    BillingAllocationKey["FUEL_SURCHARGE"] = "fuel_surcharge";
    BillingAllocationKey["REMOTE_AREA_SURCHARGE"] = "remote_area_surcharge";
})(BillingAllocationKey = exports.BillingAllocationKey || (exports.BillingAllocationKey = {}));
var BillingMetricKey;
(function (BillingMetricKey) {
    BillingMetricKey["ADJUSTMENT_TRANSACTIONS_COUNT"] = "adjustment_transactions_count";
    BillingMetricKey["ADJUSTMENT_TRANSACTIONS_TOTAL"] = "adjustment_transactions_total";
    BillingMetricKey["CAPTURE_TRANSACTIONS_COUNT"] = "capture_transactions_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_RECONCILE_PAYMENTS_COUNT"] = "capture_transactions_reconcile_payments_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_IGNORED_FRAUD_COUNT"] = "capture_transactions_ignored_fraud_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_IGNORED_FULLY_REFUNDED_COUNT"] = "capture_transactions_ignored_fully_refunded_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_IGNORED_OTHER_COUNT"] = "capture_transactions_ignored_other_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_IGNORED_PREVIOUSLY_PROCESSED_COUNT"] = "capture_transactions_ignored_previously_processed_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_SUCCEEDED_THEN_FAILED_COUNT"] = "capture_transactions_succeeded_then_failed_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_SUCCEEDED_THEN_FAILED_TOTAL"] = "capture_transactions_succeeded_then_failed_total";
    BillingMetricKey["CAPTURE_TRANSACTIONS_SUCCEEDED_THEN_FAILED_SAME_DAY_COUNT"] = "capture_transactions_succeeded_then_failed_same_day_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_SUCCEEDED_THEN_FAILED_SAME_DAY_TOTAL"] = "capture_transactions_succeeded_then_failed_same_day_total";
    BillingMetricKey["CAPTURE_QUEUED_COUNT"] = "capture_queued_count";
    BillingMetricKey["CAPTURE_TRANSACTIONS_TOTAL"] = "capture_transactions_total";
    BillingMetricKey["CARRIER_CHARGE_TRANSACTIONS_COUNT"] = "carrier_charge_transactions_count";
    BillingMetricKey["CARRIER_CHARGE_TRANSACTIONS_TOTAL"] = "carrier_charge_transactions_total";
    BillingMetricKey["CHANNEL_TRANSACTIONS_PROCESSING_COUNT"] = "channel_transactions_processing_count";
    BillingMetricKey["CHANNEL_TRANSACTIONS_PROCESSING_TOTAL"] = "channel_transactions_processing_total";
    BillingMetricKey["CHANNEL_TRANSACTIONS_ADJUSTMENT_COUNT"] = "channel_transactions_adjustment_count";
    BillingMetricKey["CHANNEL_TRANSACTIONS_ADJUSTMENT_TOTAL"] = "channel_transactions_adjustment_total";
    BillingMetricKey["CHANNEL_TRANSACTIONS_REVERSAL_COUNT"] = "channel_transactions_reversal_count";
    BillingMetricKey["CHANNEL_TRANSACTIONS_REVERSAL_TOTAL"] = "channel_transactions_reversal_total";
    BillingMetricKey["CHANNEL_BILLED_TRANSACTIONS_COUNT"] = "channel_billed_transactions_count";
    BillingMetricKey["CHANNEL_BILLED_TRANSACTIONS_TOTAL"] = "channel_billed_transactions_total";
    BillingMetricKey["CREDIT_PAYMENT_TRANSACTIONS_COUNT"] = "credit_payment_transactions_count";
    BillingMetricKey["CREDIT_PAYMENT_TRANSACTIONS_TOTAL"] = "credit_payment_transactions_total";
    BillingMetricKey["DUTY_TO_LABELS_RATIO"] = "duty_to_labels_ratio";
    BillingMetricKey["DUTY_TRANSACTIONS_COUNT"] = "duty_transactions_count";
    BillingMetricKey["DUTY_TRANSACTIONS_TOTAL"] = "duty_transactions_total";
    BillingMetricKey["FULLY_SUBSIDIZED_ORDER_TRANSACTIONS_COUNT"] = "fully_subsidized_order_transactions_count";
    BillingMetricKey["FULLY_SUBSIDIZED_ORDER_TRANSACTIONS_TOTAL"] = "fully_subsidized_order_transactions_total";
    BillingMetricKey["BILLABLE_LABEL_TRANSACTIONS_COUNT"] = "billable_label_transactions_count";
    BillingMetricKey["BILLABLE_LABEL_TRANSACTIONS_COUNT_FOR_UNIQUE_ORDERS"] = "billable_label_transactions_count_for_unique_orders";
    BillingMetricKey["BILLABLE_LABEL_TRANSACTIONS_COUNT_WITH_REVENUE_SHARE"] = "billable_label_transactions_count_with_revenue_share";
    BillingMetricKey["BILLABLE_LABEL_TRANSACTIONS_COUNT_WITHOUT_REVENUE_SHARE"] = "billable_label_transactions_count_without_revenue_share";
    BillingMetricKey["BILLABLE_LABEL_TRANSACTIONS_TOTAL"] = "billable_label_transactions_total";
    BillingMetricKey["REVENUE_SHARE_LABEL_TRANSACTIONS_COUNT"] = "revenue_share_label_transactions_count";
    BillingMetricKey["REVENUE_SHARE_LABEL_TRANSACTIONS_COUNT_FOR_UNIQUE_ORDERS"] = "revenue_share_label_transactions_count_for_unique_orders";
    BillingMetricKey["REVENUE_SHARE_LABEL_TRANSACTIONS_TOTAL"] = "revenue_share_label_transactions_total";
    BillingMetricKey["MANUAL_TRANSACTIONS_COUNT"] = "manual_transactions_count";
    BillingMetricKey["MANUAL_TRANSACTIONS_TOTAL"] = "manual_transactions_total";
    BillingMetricKey["ORDER_TRANSACTIONS_COUNT"] = "order_transactions_count";
    BillingMetricKey["ORDER_TRANSACTIONS_TOTAL"] = "order_transactions_total";
    BillingMetricKey["REFUND_TRANSACTIONS_COUNT"] = "refund_transactions_count";
    BillingMetricKey["REFUND_TRANSACTIONS_RECONCILE_PAYMENTS_COUNT"] = "refund_transactions_reconcile_payments_count";
    BillingMetricKey["REFUND_TRANSACTIONS_IGNORED_FRAUD_COUNT"] = "refund_transactions_ignored_fraud_count";
    BillingMetricKey["REFUND_TRANSACTIONS_IGNORED_FULLY_REFUNDED_COUNT"] = "refund_transactions_ignored_fully_refunded_count";
    BillingMetricKey["REFUND_TRANSACTIONS_IGNORED_OTHER_COUNT"] = "refund_transactions_ignored_other_count";
    BillingMetricKey["REFUND_TRANSACTIONS_IGNORED_PREVIOUSLY_PROCESSED_COUNT"] = "refund_transactions_ignored_previously_processed_count";
    BillingMetricKey["REFUND_QUEUED_COUNT"] = "refund_queued_count";
    BillingMetricKey["REFUND_TRANSACTIONS_TOTAL"] = "refund_transactions_total";
    BillingMetricKey["REFUND_TRANSACTIONS_SUCCEEDED_THEN_FAILED_COUNT"] = "refund_transactions_succeeded_then_failed_count";
    BillingMetricKey["REFUND_TRANSACTIONS_SUCCEEDED_THEN_FAILED_TOTAL"] = "refund_transactions_succeeded_then_failed_total";
    BillingMetricKey["REFUND_TRANSACTIONS_SUCCEEDED_THEN_FAILED_SAME_DAY_COUNT"] = "refund_transactions_succeeded_then_failed_same_day_count";
    BillingMetricKey["REFUND_TRANSACTIONS_SUCCEEDED_THEN_FAILED_SAME_DAY_TOTAL"] = "refund_transactions_succeeded_then_failed_same_day_total";
    BillingMetricKey["REVERSAL_ORDER_CANCELLATIONS_TRANSACTIONS_COUNT"] = "reversal_order_cancellations_transactions_count";
    BillingMetricKey["REVERSAL_ORDER_CANCELLATIONS_TRANSACTIONS_TOTAL"] = "reversal_order_cancellations_transactions_total";
    BillingMetricKey["REVERSAL_EXTERNAL_FULFILLMENT_TRANSACTIONS_COUNT"] = "reversal_external_fulfillment_transactions_count";
    BillingMetricKey["REVERSAL_EXTERNAL_FULFILLMENT_TRANSACTIONS_TOTAL"] = "reversal_external_fulfillment_transactions_total";
    BillingMetricKey["REVERSAL_OTHER_TRANSACTIONS_COUNT"] = "reversal_other_transactions_count";
    BillingMetricKey["REVERSAL_OTHER_TRANSACTIONS_TOTAL"] = "reversal_other_transactions_total";
    BillingMetricKey["REVERSAL_ALL_TRANSACTIONS_COUNT"] = "reversal_all_transactions_count";
    BillingMetricKey["REVERSAL_ALL_TRANSACTIONS_TOTAL"] = "reversal_all_transactions_total";
    BillingMetricKey["TAX_TO_LABELS_RATIO"] = "tax_to_labels_ratio";
    BillingMetricKey["TAX_TRANSACTIONS_COUNT"] = "tax_transactions_count";
    BillingMetricKey["TAX_TRANSACTIONS_TOTAL"] = "tax_transactions_total";
    BillingMetricKey["TRANSFER_TRANSACTIONS_COUNT"] = "transfer_transactions_count";
    BillingMetricKey["TRANSFER_TRANSACTIONS_TOTAL"] = "transfer_transactions_total";
    BillingMetricKey["TRUEUP_TRANSACTIONS_COUNT"] = "trueup_transactions_count";
    BillingMetricKey["TRUEUP_TRANSACTIONS_TOTAL"] = "trueup_transactions_total";
    BillingMetricKey["FULFILLMENTS_COUNT"] = "fulfillments_count";
    BillingMetricKey["FULFILLED_VIA_REPLACEMENT_ORDER_COUNT"] = "fulfilled_via_replacement_order_count";
    BillingMetricKey["PERCENTAGE_ORDERS_WITH_FULFILLMENT_PROOF_2_WEEKS"] = "percentage_orders_with_fulfillment_proof_2_weeks";
    BillingMetricKey["PERCENTAGE_ORDERS_WITH_FULFILLMENT_PROOF_4_WEEKS"] = "percentage_orders_with_fulfillment_proof_4_weeks";
    BillingMetricKey["PERCENTAGE_ORDERS_WITH_FULFILLMENT_PROOF_6_WEEKS"] = "percentage_orders_with_fulfillment_proof_6_weeks";
    BillingMetricKey["PERCENTAGE_ORDERS_WITH_FULFILLMENT_PROOF_ALL"] = "percentage_orders_with_fulfillment_proof_all";
    BillingMetricKey["PENDING_PAYOUTS_MAX_AGE_IN_MILLIS"] = "pending_payouts_max_age_in_millis";
    BillingMetricKey["SHIPPING_NOTIFICATIONS_COUNT"] = "shipping_notifications_count";
    BillingMetricKey["QUEUED_CAPTURE_UNPROCESSED_COUNT"] = "queued_capture_unprocessed_count";
    BillingMetricKey["QUEUED_REFUND_UNPROCESSED_COUNT"] = "queued_refund_unprocessed_count";
    BillingMetricKey["QUEUED_LABEL_INVOICE_REQUEST_UNPROCESSED_COUNT"] = "queued_label_invoice_request_unprocessed_count";
    BillingMetricKey["QUEUED_OTHER_UNPROCESSED_COUNT"] = "queued_other_unprocessed_count";
    BillingMetricKey["TASK_SNOOZE_COUNT"] = "task_snooze_count";
    BillingMetricKey["TASK_SNOOZE_ENDING_IN_48_HOURS_COUNT"] = "task_snooze_ending_in_48_hours_count";
    BillingMetricKey["PAYOUTS_SCHEDULED_COUNT"] = "payouts_scheduled_count";
    BillingMetricKey["PAYOUTS_SCHEDULED_TOTAL"] = "payouts_scheduled_total";
    BillingMetricKey["PAYOUTS_SENT_COUNT"] = "payouts_sent_count";
    BillingMetricKey["PAYOUTS_SENT_TOTAL"] = "payouts_sent_total";
    BillingMetricKey["PAYOUTS_FAILED_COUNT"] = "payouts_failed_count";
    BillingMetricKey["PAYOUTS_FAILED_TOTAL"] = "payouts_failed_total";
    BillingMetricKey["AVERAGE_PAYOUT_AMOUNT"] = "average_payout_amount";
    BillingMetricKey["CAPTURE_TRANSACTION_WITH_ZERO_FEES_AND_NO_CHANNEL_TRANSACTION_COUNT"] = "capture_transaction_with_zero_fees_and_no_channel_transaction_count";
    BillingMetricKey["PERCENTAGE_BILLABLE_LABEL_TRANSACTIONS_WITH_CARRIER_CHARGE_10_DAYS"] = "percentage_billable_label_transactions_with_carrier_charge_10_days";
    BillingMetricKey["PERCENTAGE_BILLABLE_LABEL_TRANSACTIONS_WITH_CARRIER_CHARGE_20_DAYS"] = "percentage_billable_label_transactions_with_carrier_charge_20_days";
    BillingMetricKey["PERCENTAGE_BILLABLE_LABEL_TRANSACTIONS_WITH_CARRIER_CHARGE_30_DAYS"] = "percentage_billable_label_transactions_with_carrier_charge_30_days";
    BillingMetricKey["PERCENTAGE_BILLABLE_LABEL_TRANSACTIONS_WITH_CARRIER_CHARGE_60_DAYS"] = "percentage_billable_label_transactions_with_carrier_charge_60_days";
    BillingMetricKey["PERCENTAGE_BILLABLE_LABEL_TRANSACTIONS_WITH_CARRIER_CHARGE_90_DAYS"] = "percentage_billable_label_transactions_with_carrier_charge_90_days";
    BillingMetricKey["PERCENTAGE_BANK_ACCOUNT_INSERTS"] = "percentage_bank_account_inserts";
    BillingMetricKey["PERCENTAGE_BANK_ACCOUNT_UPDATES"] = "percentage_bank_account_updates";
    BillingMetricKey["PERCENTAGE_BANK_ACCOUNT_UNIQUE_UPDATES"] = "percentage_bank_account_unique_updates";
    BillingMetricKey["PERCENTAGE_BANK_ACCOUNT_DELETES"] = "percentage_bank_account_deletes";
    BillingMetricKey["NEGATIVE_BALANCE_NUMBER_ACCOUNTS"] = "negative_balance_number_accounts";
    BillingMetricKey["NEGATIVE_BALANCE_NUMBER_ACCOUNTS_WITH_ORDER_IN_PAST_30_DAYS"] = "negative_balance_number_accounts_with_order_in_past_30_days";
    BillingMetricKey["NEGATIVE_BALANCE_NUMBER_ACCOUNTS_WITHOUT_ORDER_IN_PAST_30_DAYS"] = "negative_balance_number_accounts_without_order_in_past_30_days";
    BillingMetricKey["NEGATIVE_BALANCE_NUMBER_OFFBOARDED_ACCOUNTS"] = "negative_balance_number_offboarded_accounts";
    BillingMetricKey["NEGATIVE_BALANCE_NUMBER_ACTIVE_ACCOUNTS_WITH_BALANCE_OVER_1000"] = "negative_balance_number_active_accounts_with_balance_over_1000";
    BillingMetricKey["NEGATIVE_BALANCE_TOTAL"] = "negative_balance_total";
    BillingMetricKey["NEGATIVE_BALANCE_TOTAL_WITH_ORDER_IN_PAST_30_DAYS"] = "negative_balance_total_with_order_in_past_30_days";
    BillingMetricKey["NEGATIVE_BALANCE_TOTAL_WITHOUT_ORDER_IN_PAST_30_DAYS"] = "negative_balance_total_without_order_in_past_30_days";
    BillingMetricKey["NEGATIVE_BALANCE_TOTAL_OFFBOARDED_ACCOUNTS"] = "negative_balance_total_offboarded_accounts";
    BillingMetricKey["NEGATIVE_BALANCE_SINGLE_ACCOUNT_MAX"] = "negative_balance_single_account_max";
    BillingMetricKey["NEGATIVE_BALANCE_SINGLE_ACTIVE_ACCOUNT_MAX"] = "negative_balance_single_active_account_max";
    BillingMetricKey["NEGATIVE_BALANCE_FEE_TOTAL"] = "negative_balance_fee_total";
    BillingMetricKey["ACCOUNTS_WITH_PAYMENT_HOLDS_COUNT"] = "accounts_with_payment_holds_count";
    BillingMetricKey["ACCOUNTS_WITH_PAYMENT_HOLDS_PENDING_PAYMENT_PROMISE_COUNT"] = "accounts_with_payment_holds_pending_payment_promise_count";
    BillingMetricKey["ACCOUNTS_WITH_PAYMENT_HOLDS_PENDING_PAYMENT_PROMISE_TOTAL"] = "accounts_with_payment_holds_pending_payment_promise_total";
    BillingMetricKey["EDITED_ORDER_TAX_AMOUNT_EXCEEDING_TRANSACTION"] = "edited_order_tax_amount_exceeding_transaction";
    BillingMetricKey["EDITED_ORDER_DUTY_AMOUNT_EXCEEDING_TRANSACTION"] = "edited_order_duty_amount_exceeding_transaction";
    BillingMetricKey["NEGATIVE_BALANCE_SCHEDULED_COUNT"] = "negative_balance_scheduled_count";
    BillingMetricKey["NEGATIVE_BALANCE_SCHEDULED_TOTAL"] = "negative_balance_scheduled_total";
    BillingMetricKey["NEGATIVE_BALANCE_SENT_COUNT"] = "negative_balance_sent_count";
    BillingMetricKey["NEGATIVE_BALANCE_SENT_TOTAL"] = "negative_balance_sent_total";
    BillingMetricKey["NEGATIVE_BALANCE_FAILED_COUNT"] = "negative_balance_failed_count";
    BillingMetricKey["NEGATIVE_BALANCE_FAILED_TOTAL"] = "negative_balance_failed_total";
    BillingMetricKey["NEGATIVE_DEBIT_SUCCESS_RATE"] = "negative_debit_success_rate";
    BillingMetricKey["CURRENT_ATTEMPT_MERCHANT_COUNT"] = "current_attempt_merchant_count";
    BillingMetricKey["CURRENT_ATTEMPT_AMOUNT_TOTAL"] = "current_attempt_amount_total";
    BillingMetricKey["CURRENT_ATTEMPT_FAILED_MERCHANT_COUNT"] = "current_attempt_failed_merchant_count";
    BillingMetricKey["CURRENT_ATTEMPT_FAILED_AMOUNT_TOTAL"] = "current_attempt_failed_amount_total";
    BillingMetricKey["CURRENT_ATTEMPT_SUCCESS_RATIO"] = "current_attempt_success_ratio";
    BillingMetricKey["FIRST_ATTEMPT_MERCHANT_COUNT"] = "first_attempt_merchant_count";
    BillingMetricKey["FIRST_ATTEMPT_AMOUNT_TOTAL"] = "first_attempt_amount_total";
    BillingMetricKey["FIRST_ATTEMPT_FAILED_MERCHANT_COUNT"] = "first_attempt_failed_merchant_count";
    BillingMetricKey["FIRST_ATTEMPT_FAILED_AMOUNT_TOTAL"] = "first_attempt_failed_amount_total";
    BillingMetricKey["FIRST_ATTEMPT_SUCCESS_RATIO"] = "first_attempt_success_ratio";
    BillingMetricKey["SECOND_ATTEMPT_MERCHANT_COUNT"] = "second_attempt_merchant_count";
    BillingMetricKey["SECOND_ATTEMPT_AMOUNT_TOTAL"] = "second_attempt_amount_total";
    BillingMetricKey["SECOND_ATTEMPT_FAILED_MERCHANT_COUNT"] = "second_attempt_failed_merchant_count";
    BillingMetricKey["SECOND_ATTEMPT_FAILED_AMOUNT_TOTAL"] = "second_attempt_failed_amount_total";
    BillingMetricKey["SECOND_ATTEMPT_SUCCESS_RATIO"] = "second_attempt_success_ratio";
    BillingMetricKey["THIRD_ATTEMPT_MERCHANT_COUNT"] = "third_attempt_merchant_count";
    BillingMetricKey["THIRD_ATTEMPT_AMOUNT_TOTAL"] = "third_attempt_amount_total";
    BillingMetricKey["THIRD_ATTEMPT_FAILED_MERCHANT_COUNT"] = "third_attempt_failed_merchant_count";
    BillingMetricKey["THIRD_ATTEMPT_FAILED_AMOUNT_TOTAL"] = "third_attempt_failed_amount_total";
    BillingMetricKey["THIRD_ATTEMPT_SUCCESS_RATIO"] = "third_attempt_success_ratio";
    BillingMetricKey["FOURTH_PLUS_ATTEMPT_MERCHANT_COUNT"] = "fourth_plus_attempt_merchant_count";
    BillingMetricKey["FOURTH_PLUS_ATTEMPT_AMOUNT_TOTAL"] = "fourth_plus_attempt_amount_total";
    BillingMetricKey["FOURTH_PLUS_ATTEMPT_FAILED_MERCHANT_COUNT"] = "fourth_plus_attempt_failed_merchant_count";
    BillingMetricKey["FOURTH_PLUS_ATTEMPT_FAILED_AMOUNT_TOTAL"] = "fourth_plus_attempt_failed_amount_total";
    BillingMetricKey["FOURTH_PLUS_ATTEMPT_SUCCESS_RATIO"] = "fourth_plus_attempt_success_ratio";
})(BillingMetricKey = exports.BillingMetricKey || (exports.BillingMetricKey = {}));
var BillingStatementAttachmentKey;
(function (BillingStatementAttachmentKey) {
    BillingStatementAttachmentKey["INVOICE"] = "invoice";
    BillingStatementAttachmentKey["STATEMENT"] = "statement";
    BillingStatementAttachmentKey["CONSUMER_INVOICE"] = "consumer_invoice";
    BillingStatementAttachmentKey["CREDIT_MEMO"] = "credit_memo";
    BillingStatementAttachmentKey["CHANNEL_BILLED"] = "channel_billed";
    BillingStatementAttachmentKey["TRANSACTIONS"] = "transactions";
    BillingStatementAttachmentKey["VIRTUAL_CARD"] = "virtual_card";
    BillingStatementAttachmentKey["TAX_REMITTANCE"] = "tax_remittance";
    BillingStatementAttachmentKey["MANUAL"] = "manual";
    BillingStatementAttachmentKey["ORDERS"] = "orders";
    BillingStatementAttachmentKey["LABEL"] = "label";
    BillingStatementAttachmentKey["ORDER_SERVICE"] = "order_service";
    BillingStatementAttachmentKey["TAX"] = "tax";
    BillingStatementAttachmentKey["DUTY"] = "duty";
    BillingStatementAttachmentKey["TRUEUP"] = "trueup";
    BillingStatementAttachmentKey["CARRIER_CHARGE"] = "carrier_charge";
    BillingStatementAttachmentKey["ALL"] = "all";
})(BillingStatementAttachmentKey = exports.BillingStatementAttachmentKey || (exports.BillingStatementAttachmentKey = {}));
var BillingTransactionStatus;
(function (BillingTransactionStatus) {
    BillingTransactionStatus["PENDING_PROOF"] = "pending_proof";
    BillingTransactionStatus["POSTED"] = "posted";
})(BillingTransactionStatus = exports.BillingTransactionStatus || (exports.BillingTransactionStatus = {}));
var BillingTransactionType;
(function (BillingTransactionType) {
    BillingTransactionType["MANUAL"] = "manual";
    BillingTransactionType["SUBSCRIPTION"] = "subscription";
    BillingTransactionType["INVOICE"] = "invoice";
    BillingTransactionType["TRANSFER"] = "transfer";
    BillingTransactionType["ADJUSTMENT"] = "adjustment";
    BillingTransactionType["REVERSAL"] = "reversal";
    BillingTransactionType["CAPTURE"] = "capture";
    BillingTransactionType["REFUND"] = "refund";
    BillingTransactionType["VIRTUAL_CARD_CAPTURE"] = "virtual_card_capture";
    BillingTransactionType["VIRTUAL_CARD_REFUND"] = "virtual_card_refund";
    BillingTransactionType["TAX_REMITTANCE"] = "tax_remittance";
    BillingTransactionType["FULLY_SUBSIDIZED_ORDER"] = "fully_subsidized_order";
    BillingTransactionType["CREDIT_PAYMENT"] = "credit_payment";
    BillingTransactionType["DISPUTE"] = "dispute";
    BillingTransactionType["CHANNEL"] = "channel";
    BillingTransactionType["LABEL"] = "label";
    BillingTransactionType["ORDER"] = "order";
    BillingTransactionType["CHANNEL_BILLED"] = "channel_billed";
    BillingTransactionType["TAX"] = "tax";
    BillingTransactionType["DUTY"] = "duty";
    BillingTransactionType["TRUEUP"] = "trueup";
    BillingTransactionType["CARRIER_CHARGE"] = "carrier_charge";
    BillingTransactionType["NON_L_4_L_TAX_DUTY_FX"] = "non_l4l_tax_duty_fx";
    BillingTransactionType["TAX_REFUND"] = "tax_refund";
    BillingTransactionType["DUTY_REFUND"] = "duty_refund";
    BillingTransactionType["GE_REVENUE_SHARE"] = "ge_revenue_share";
    BillingTransactionType["TAX_DUTY_DELTA"] = "tax_duty_delta";
})(BillingTransactionType = exports.BillingTransactionType || (exports.BillingTransactionType = {}));
var BrowserBundleErrorCode;
(function (BrowserBundleErrorCode) {
    BrowserBundleErrorCode["GENERIC_ERROR"] = "generic_error";
    BrowserBundleErrorCode["COUNTRY_INVALID"] = "country_invalid";
})(BrowserBundleErrorCode = exports.BrowserBundleErrorCode || (exports.BrowserBundleErrorCode = {}));
var CalculatorEngine;
(function (CalculatorEngine) {
    CalculatorEngine["DTCE_WITH_DEMINIMIS"] = "dtce_with_deminimis";
    CalculatorEngine["DTCE_WITH_INCLUSIVE_PRICING"] = "dtce_with_inclusive_pricing";
    CalculatorEngine["DTCE_AND_US_TAX"] = "dtce_and_us_tax";
})(CalculatorEngine = exports.CalculatorEngine || (exports.CalculatorEngine = {}));
var CarrierChargeTransactionType;
(function (CarrierChargeTransactionType) {
    CarrierChargeTransactionType["ADJUSTMENT"] = "adjustment";
    CarrierChargeTransactionType["REVERSAL"] = "reversal";
    CarrierChargeTransactionType["CHARGE"] = "charge";
    CarrierChargeTransactionType["REVENUE_SHARE"] = "revenue_share";
})(CarrierChargeTransactionType = exports.CarrierChargeTransactionType || (exports.CarrierChargeTransactionType = {}));
var CarrierChargeType;
(function (CarrierChargeType) {
    CarrierChargeType["LABEL"] = "label";
    CarrierChargeType["TAX"] = "tax";
    CarrierChargeType["OTHER"] = "other";
})(CarrierChargeType = exports.CarrierChargeType || (exports.CarrierChargeType = {}));
var CarrierFileType;
(function (CarrierFileType) {
    CarrierFileType["FREIGHT"] = "freight";
    CarrierFileType["TAX"] = "tax";
})(CarrierFileType = exports.CarrierFileType || (exports.CarrierFileType = {}));
var CarrierLabelGenerationMethod;
(function (CarrierLabelGenerationMethod) {
    CarrierLabelGenerationMethod["DIRECT"] = "direct";
    CarrierLabelGenerationMethod["EASYPOST"] = "easypost";
})(CarrierLabelGenerationMethod = exports.CarrierLabelGenerationMethod || (exports.CarrierLabelGenerationMethod = {}));
var CarrierValidationStatus;
(function (CarrierValidationStatus) {
    CarrierValidationStatus["SUCCESS"] = "success";
    CarrierValidationStatus["ERROR"] = "error";
})(CarrierValidationStatus = exports.CarrierValidationStatus || (exports.CarrierValidationStatus = {}));
var CatalogImportType;
(function (CatalogImportType) {
    CatalogImportType["CATALOG_ITEMS"] = "catalog_items";
    CatalogImportType["ITEM_FORM_OVERLAYS"] = "item_form_overlays";
    CatalogImportType["ITEM_PRICES"] = "item_prices";
    CatalogImportType["PRICE_BOOK_ITEMS_IMPORT"] = "price_book_items_import";
    CatalogImportType["PRICE_BOOK_ITEMS_QUERY_IMPORT"] = "price_book_items_query_import";
})(CatalogImportType = exports.CatalogImportType || (exports.CatalogImportType = {}));
var ChannelBilledTransactionType;
(function (ChannelBilledTransactionType) {
    ChannelBilledTransactionType["ADJUSTMENT"] = "adjustment";
    ChannelBilledTransactionType["REVERSAL"] = "reversal";
    ChannelBilledTransactionType["CHANNEL_INITIATED"] = "channel_initiated";
})(ChannelBilledTransactionType = exports.ChannelBilledTransactionType || (exports.ChannelBilledTransactionType = {}));
var ChannelOrderAcceptanceErrorAction;
(function (ChannelOrderAcceptanceErrorAction) {
    ChannelOrderAcceptanceErrorAction["AUTO_REJECT"] = "auto_reject";
    ChannelOrderAcceptanceErrorAction["AUTO_ACCEPT"] = "auto_accept";
})(ChannelOrderAcceptanceErrorAction = exports.ChannelOrderAcceptanceErrorAction || (exports.ChannelOrderAcceptanceErrorAction = {}));
var ChannelOrderAcceptanceFailureReasonCode;
(function (ChannelOrderAcceptanceFailureReasonCode) {
    ChannelOrderAcceptanceFailureReasonCode["CHANNEL_ORDER_MOR_INVALID"] = "channel_order_mor_invalid";
    ChannelOrderAcceptanceFailureReasonCode["CHANNEL_ORDER_DOES_NOT_EXIST"] = "channel_order_does_not_exist";
})(ChannelOrderAcceptanceFailureReasonCode = exports.ChannelOrderAcceptanceFailureReasonCode || (exports.ChannelOrderAcceptanceFailureReasonCode = {}));
var ChannelOrderAcceptanceNextActionFrom;
(function (ChannelOrderAcceptanceNextActionFrom) {
    ChannelOrderAcceptanceNextActionFrom["CX_TEAM"] = "cx_team";
    ChannelOrderAcceptanceNextActionFrom["CORE_TEAM"] = "core_team";
    ChannelOrderAcceptanceNextActionFrom["CORE_TEAM_INVESTIGATE"] = "core_team_investigate";
    ChannelOrderAcceptanceNextActionFrom["MEX_TEAM"] = "mex_team";
    ChannelOrderAcceptanceNextActionFrom["PAYMENTS_TEAM"] = "payments_team";
    ChannelOrderAcceptanceNextActionFrom["TC_TEAM"] = "tc_team";
    ChannelOrderAcceptanceNextActionFrom["LOGISTICS_TEAM"] = "logistics_team";
})(ChannelOrderAcceptanceNextActionFrom = exports.ChannelOrderAcceptanceNextActionFrom || (exports.ChannelOrderAcceptanceNextActionFrom = {}));
var ChannelOrderAcceptanceRejectionReason;
(function (ChannelOrderAcceptanceRejectionReason) {
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_ORIGIN_COUNTRY"] = "unsupported_origin_country";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_DESTINATION_COUNTRY"] = "unsupported_destination_country";
    ChannelOrderAcceptanceRejectionReason["DOMESTIC_ORDER"] = "domestic_order";
    ChannelOrderAcceptanceRejectionReason["ORDER_CONTAINS_GIFT_CARD"] = "order_contains_gift_card";
    ChannelOrderAcceptanceRejectionReason["ORDER_CONTAINS_RESTRICTED_GOODS"] = "order_contains_restricted_goods";
    ChannelOrderAcceptanceRejectionReason["MISSING_ORDER_INFORMATION"] = "missing_order_information";
    ChannelOrderAcceptanceRejectionReason["MISSING_CLASSIFICATION_INFORMATION"] = "missing_classification_information";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_PAYMENT_INFORMATION"] = "unsupported_payment_information";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_SHOP_CURRENCY"] = "unsupported_shop_currency";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_FREE_ORDER"] = "unsupported_free_order";
    ChannelOrderAcceptanceRejectionReason["EXTRACTING_DISTRIBUTION_INFO_FAILED"] = "extracting_distribution_info_failed";
    ChannelOrderAcceptanceRejectionReason["SHIPPING_ESTIMATION_FAILED"] = "shipping_estimation_failed";
    ChannelOrderAcceptanceRejectionReason["PAYMENT_AUTHORIZATION_FAILED"] = "payment_authorization_failed";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_SUBSIDIZED_ORDER"] = "unsupported_subsidized_order";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_VIRTUAL_GOODS"] = "unsupported_virtual_goods";
    ChannelOrderAcceptanceRejectionReason["NON_MATCHING_CURRENCIES"] = "non_matching_currencies";
    ChannelOrderAcceptanceRejectionReason["UNSUPPORTED_ORDER_EDIT"] = "unsupported_order_edit";
    ChannelOrderAcceptanceRejectionReason["ORDER_MISSING"] = "order_missing";
})(ChannelOrderAcceptanceRejectionReason = exports.ChannelOrderAcceptanceRejectionReason || (exports.ChannelOrderAcceptanceRejectionReason = {}));
var ChannelOrderAcceptanceStatus;
(function (ChannelOrderAcceptanceStatus) {
    ChannelOrderAcceptanceStatus["ACCEPTED"] = "accepted";
    ChannelOrderAcceptanceStatus["REJECTED"] = "rejected";
    ChannelOrderAcceptanceStatus["REVIEW"] = "review";
    ChannelOrderAcceptanceStatus["EDIT_REVIEW"] = "edit_review";
    ChannelOrderAcceptanceStatus["EDIT_ACCEPTED"] = "edit_accepted";
})(ChannelOrderAcceptanceStatus = exports.ChannelOrderAcceptanceStatus || (exports.ChannelOrderAcceptanceStatus = {}));
var ChannelOrderFulfillmentStatusCode;
(function (ChannelOrderFulfillmentStatusCode) {
    ChannelOrderFulfillmentStatusCode["UNFULFILLED"] = "unfulfilled";
    ChannelOrderFulfillmentStatusCode["FULFILLED"] = "fulfilled";
    ChannelOrderFulfillmentStatusCode["PARTIAL"] = "partial";
    ChannelOrderFulfillmentStatusCode["CANCELLED"] = "cancelled";
})(ChannelOrderFulfillmentStatusCode = exports.ChannelOrderFulfillmentStatusCode || (exports.ChannelOrderFulfillmentStatusCode = {}));
var ChannelTransactionType;
(function (ChannelTransactionType) {
    ChannelTransactionType["ADJUSTMENT"] = "adjustment";
    ChannelTransactionType["REVERSAL"] = "reversal";
    ChannelTransactionType["PROCESSING"] = "processing";
})(ChannelTransactionType = exports.ChannelTransactionType || (exports.ChannelTransactionType = {}));
var ChargeEstimateSource;
(function (ChargeEstimateSource) {
    ChargeEstimateSource["GLOBAL_E"] = "global-e";
    ChargeEstimateSource["SHOPIFY"] = "shopify";
})(ChargeEstimateSource = exports.ChargeEstimateSource || (exports.ChargeEstimateSource = {}));
var ChargeInputType;
(function (ChargeInputType) {
    ChargeInputType["FUELSC"] = "fuelsc";
    ChargeInputType["INCOTERM_DDP"] = "incoterm_ddp";
    ChargeInputType["DELIVERY_CONFIRMATION"] = "delivery_confirmation";
    ChargeInputType["BASE_CHARGE"] = "base_charge";
    ChargeInputType["PACKAGE_PICKUP"] = "package_pickup";
    ChargeInputType["INSURANCE"] = "insurance";
    ChargeInputType["USPS_FIRST_MILE"] = "usps_first_mile";
    ChargeInputType["OVERSIZE_PIECE"] = "oversize_piece";
    ChargeInputType["INCOTERM_DAP"] = "incoterm_dap";
    ChargeInputType["EMERGENCY_SITUATION"] = "emergency_situation";
    ChargeInputType["REMOTE_AREA_DELIVERY"] = "remote_area_delivery";
    ChargeInputType["CUSTOMS_CLEARANCE_SURCHARGE"] = "customs_clearance_surcharge";
    ChargeInputType["SECURITY_SURCHARGE"] = "security_surcharge";
    ChargeInputType["DUTIES_FX_SURCHARGE"] = "duties_fx_surcharge";
    ChargeInputType["ELECTRONIC_EXPORT_INFORMATION_SURCHARGE"] = "electronic_export_information_surcharge";
    ChargeInputType["ADDITIONAL_HANDLING"] = "additional_handling";
    ChargeInputType["LARGE_PACKAGE_SURCHARGE"] = "large_package_surcharge";
    ChargeInputType["PEAK_SURCHARGE"] = "peak_surcharge";
})(ChargeInputType = exports.ChargeInputType || (exports.ChargeInputType = {}));
var ChargebackPaymentStatus;
(function (ChargebackPaymentStatus) {
    ChargebackPaymentStatus["CAPTURED"] = "captured";
    ChargebackPaymentStatus["REFUNDED"] = "refunded";
})(ChargebackPaymentStatus = exports.ChargebackPaymentStatus || (exports.ChargebackPaymentStatus = {}));
var ChargebackProcessStatus;
(function (ChargebackProcessStatus) {
    ChargebackProcessStatus["INQUIRY"] = "inquiry";
    ChargebackProcessStatus["OPEN"] = "open";
    ChargebackProcessStatus["CLOSED"] = "closed";
})(ChargebackProcessStatus = exports.ChargebackProcessStatus || (exports.ChargebackProcessStatus = {}));
var CheckoutAssetType;
(function (CheckoutAssetType) {
    CheckoutAssetType["STYLESHEET"] = "stylesheet";
    CheckoutAssetType["JAVASCRIPT"] = "javascript";
})(CheckoutAssetType = exports.CheckoutAssetType || (exports.CheckoutAssetType = {}));
var CheckoutErrorCode;
(function (CheckoutErrorCode) {
    CheckoutErrorCode["GENERIC_ERROR"] = "generic_error";
    CheckoutErrorCode["ORDER_IDENTIFIER_INVALID"] = "order_identifier_invalid";
    CheckoutErrorCode["URL_INVALID"] = "url_invalid";
    CheckoutErrorCode["ORGANIZATION_INVALID"] = "organization_invalid";
    CheckoutErrorCode["SESSION_INVALID"] = "session_invalid";
    CheckoutErrorCode["SESSION_MISSING"] = "session_missing";
    CheckoutErrorCode["SESSION_ORGANIZATION_INVALID"] = "session_organization_invalid";
    CheckoutErrorCode["COUNTRY_INVALID"] = "country_invalid";
    CheckoutErrorCode["CURRENCY_INVALID"] = "currency_invalid";
    CheckoutErrorCode["LANGUAGE_INVALID"] = "language_invalid";
    CheckoutErrorCode["CHECKOUT_INVALID"] = "checkout_invalid";
})(CheckoutErrorCode = exports.CheckoutErrorCode || (exports.CheckoutErrorCode = {}));
var CheckoutPromptBehavior;
(function (CheckoutPromptBehavior) {
    CheckoutPromptBehavior["ALWAYS"] = "always";
    CheckoutPromptBehavior["INCOMPLETE"] = "incomplete";
})(CheckoutPromptBehavior = exports.CheckoutPromptBehavior || (exports.CheckoutPromptBehavior = {}));
var CheckoutRedirectMethod;
(function (CheckoutRedirectMethod) {
    CheckoutRedirectMethod["GET"] = "get";
    CheckoutRedirectMethod["POST"] = "post";
})(CheckoutRedirectMethod = exports.CheckoutRedirectMethod || (exports.CheckoutRedirectMethod = {}));
var CheckoutShippingMethodPromptBehavior;
(function (CheckoutShippingMethodPromptBehavior) {
    CheckoutShippingMethodPromptBehavior["ALWAYS"] = "always";
    CheckoutShippingMethodPromptBehavior["MULTIPLE"] = "multiple";
})(CheckoutShippingMethodPromptBehavior = exports.CheckoutShippingMethodPromptBehavior || (exports.CheckoutShippingMethodPromptBehavior = {}));
var CheckoutUrlType;
(function (CheckoutUrlType) {
    CheckoutUrlType["CONTINUE_SHOPPING"] = "continue_shopping";
    CheckoutUrlType["CONFIRMATION"] = "confirmation";
    CheckoutUrlType["INVALID_CHECKOUT"] = "invalid_checkout";
})(CheckoutUrlType = exports.CheckoutUrlType || (exports.CheckoutUrlType = {}));
var ClassificationDecision;
(function (ClassificationDecision) {
    ClassificationDecision["ACCEPT"] = "Accept";
    ClassificationDecision["REJECT"] = "Reject";
})(ClassificationDecision = exports.ClassificationDecision || (exports.ClassificationDecision = {}));
var ClassificationErrorCode;
(function (ClassificationErrorCode) {
    ClassificationErrorCode["GENERIC_ERROR"] = "generic_error";
})(ClassificationErrorCode = exports.ClassificationErrorCode || (exports.ClassificationErrorCode = {}));
var ClassificationPlatform;
(function (ClassificationPlatform) {
    ClassificationPlatform["GLOBAL_E"] = "GlobalE";
    ClassificationPlatform["FLOW"] = "Flow";
    ClassificationPlatform["BORDER_FREE"] = "Borderfree";
})(ClassificationPlatform = exports.ClassificationPlatform || (exports.ClassificationPlatform = {}));
var ClassificationType;
(function (ClassificationType) {
    ClassificationType["NONE"] = "None";
    ClassificationType["MANUAL"] = "Manual";
    ClassificationType["ML"] = "ML";
})(ClassificationType = exports.ClassificationType || (exports.ClassificationType = {}));
var ClothingAgeClassification;
(function (ClothingAgeClassification) {
    ClothingAgeClassification["NONE"] = "None";
    ClothingAgeClassification["AGE_KIDS_GENERAL"] = "AgeKidsGeneral";
    ClothingAgeClassification["AGE_0_10"] = "Age0_10";
    ClothingAgeClassification["AGE_10_13"] = "Age10_13";
    ClothingAgeClassification["AGE_13_14"] = "Age13_14";
})(ClothingAgeClassification = exports.ClothingAgeClassification || (exports.ClothingAgeClassification = {}));
var Company;
(function (Company) {
    Company["GLOBALE"] = "globale";
    Company["FLOW"] = "flow";
})(Company = exports.Company || (exports.Company = {}));
var ComplianceType;
(function (ComplianceType) {
    ComplianceType["WEEE"] = "weee";
})(ComplianceType = exports.ComplianceType || (exports.ComplianceType = {}));
var ContentElementType;
(function (ContentElementType) {
    ContentElementType["MARKDOWN"] = "markdown";
    ContentElementType["HTML"] = "html";
    ContentElementType["PLAIN_TEXT"] = "plain_text";
    ContentElementType["HREF"] = "href";
})(ContentElementType = exports.ContentElementType || (exports.ContentElementType = {}));
var ContentStatus;
(function (ContentStatus) {
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["LIVE"] = "live";
    ContentStatus["ARCHIVED"] = "archived";
})(ContentStatus = exports.ContentStatus || (exports.ContentStatus = {}));
var ContentType;
(function (ContentType) {
    ContentType["TEXT"] = "text";
    ContentType["HTML"] = "html";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var ContentTypeCast;
(function (ContentTypeCast) {
    ContentTypeCast["MARKDOWN_TO_HTML"] = "markdown_to_html";
    ContentTypeCast["MARKDOWN_TO_TEXT"] = "markdown_to_text";
})(ContentTypeCast = exports.ContentTypeCast || (exports.ContentTypeCast = {}));
var CrossdockTrackingStatus;
(function (CrossdockTrackingStatus) {
    CrossdockTrackingStatus["NOTIFIED"] = "notified";
    CrossdockTrackingStatus["RECEIVED"] = "received";
    CrossdockTrackingStatus["SHIPPED"] = "shipped";
})(CrossdockTrackingStatus = exports.CrossdockTrackingStatus || (exports.CrossdockTrackingStatus = {}));
var DebugAccountingTransactionType;
(function (DebugAccountingTransactionType) {
    DebugAccountingTransactionType["FULFILLMENT"] = "fulfillment";
})(DebugAccountingTransactionType = exports.DebugAccountingTransactionType || (exports.DebugAccountingTransactionType = {}));
var DeliveredDutyOptionMessageType;
(function (DeliveredDutyOptionMessageType) {
    DeliveredDutyOptionMessageType["WARNING"] = "warning";
    DeliveredDutyOptionMessageType["NOTIFICATION"] = "notification";
})(DeliveredDutyOptionMessageType = exports.DeliveredDutyOptionMessageType || (exports.DeliveredDutyOptionMessageType = {}));
var DeminimisAdjustmentType;
(function (DeminimisAdjustmentType) {
    DeminimisAdjustmentType["NONE"] = "none";
    DeminimisAdjustmentType["DUTY"] = "duty";
    DeminimisAdjustmentType["VAT"] = "vat";
    DeminimisAdjustmentType["VAT_AND_DUTY"] = "vat_and_duty";
})(DeminimisAdjustmentType = exports.DeminimisAdjustmentType || (exports.DeminimisAdjustmentType = {}));
var DiscountRequestOrderEntitlementKey;
(function (DiscountRequestOrderEntitlementKey) {
    DiscountRequestOrderEntitlementKey["SUBTOTAL"] = "subtotal";
})(DiscountRequestOrderEntitlementKey = exports.DiscountRequestOrderEntitlementKey || (exports.DiscountRequestOrderEntitlementKey = {}));
var DisputeBillable;
(function (DisputeBillable) {
    DisputeBillable["FLOW"] = "flow";
    DisputeBillable["ORGANIZATION"] = "organization";
})(DisputeBillable = exports.DisputeBillable || (exports.DisputeBillable = {}));
var DisputeCategory;
(function (DisputeCategory) {
    DisputeCategory["FRIENDLY_FRAUD"] = "friendly_fraud";
    DisputeCategory["TRUE_FRAUD"] = "true_fraud";
    DisputeCategory["PROCESSING_ERROR"] = "processing_error";
})(DisputeCategory = exports.DisputeCategory || (exports.DisputeCategory = {}));
var DisputeDefenseOutcome;
(function (DisputeDefenseOutcome) {
    DisputeDefenseOutcome["DEFENDED"] = "defended";
    DisputeDefenseOutcome["UNDEFENDED"] = "undefended";
    DisputeDefenseOutcome["UNDEFENDABLE"] = "undefendable";
})(DisputeDefenseOutcome = exports.DisputeDefenseOutcome || (exports.DisputeDefenseOutcome = {}));
var DisputeEvidence;
(function (DisputeEvidence) {
    DisputeEvidence["PROOF_OF_DELIVERY"] = "proof_of_delivery";
    DisputeEvidence["PROOF_OF_FULFILLMENT"] = "proof_of_fulfillment";
    DisputeEvidence["OTHER"] = "other";
})(DisputeEvidence = exports.DisputeEvidence || (exports.DisputeEvidence = {}));
var DisputeImportStatus;
(function (DisputeImportStatus) {
    DisputeImportStatus["NEW"] = "new";
    DisputeImportStatus["PROCESSING"] = "processing";
    DisputeImportStatus["COMPLETED"] = "completed";
    DisputeImportStatus["FAILED"] = "failed";
})(DisputeImportStatus = exports.DisputeImportStatus || (exports.DisputeImportStatus = {}));
var DisputeImportType;
(function (DisputeImportType) {
    DisputeImportType["ADYEN_DISPUTE"] = "adyen_dispute";
    DisputeImportType["PAYPAL_DISPUTE"] = "paypal_dispute";
})(DisputeImportType = exports.DisputeImportType || (exports.DisputeImportType = {}));
var DisputeLiability;
(function (DisputeLiability) {
    DisputeLiability["FLOW"] = "flow";
    DisputeLiability["ORGANIZATION"] = "organization";
})(DisputeLiability = exports.DisputeLiability || (exports.DisputeLiability = {}));
var DisputeProcessor;
(function (DisputeProcessor) {
    DisputeProcessor["ADYEN"] = "adyen";
    DisputeProcessor["PAYPAL"] = "paypal";
    DisputeProcessor["STRIPE"] = "stripe";
})(DisputeProcessor = exports.DisputeProcessor || (exports.DisputeProcessor = {}));
var DisputeReportingCategory;
(function (DisputeReportingCategory) {
    DisputeReportingCategory["CHARGE_ISSUES"] = "charge_issues";
    DisputeReportingCategory["DELIVERY"] = "delivery";
    DisputeReportingCategory["FRAUD"] = "fraud";
    DisputeReportingCategory["GENERAL"] = "general";
    DisputeReportingCategory["PRODUCT"] = "product";
    DisputeReportingCategory["RETURNS"] = "returns";
})(DisputeReportingCategory = exports.DisputeReportingCategory || (exports.DisputeReportingCategory = {}));
var DisputeStatus;
(function (DisputeStatus) {
    DisputeStatus["PENDING"] = "pending";
    DisputeStatus["WON"] = "won";
    DisputeStatus["LOST"] = "lost";
    DisputeStatus["REFUNDED"] = "refunded";
    DisputeStatus["EXPIRED"] = "expired";
})(DisputeStatus = exports.DisputeStatus || (exports.DisputeStatus = {}));
var DisputeTransactionType;
(function (DisputeTransactionType) {
    DisputeTransactionType["ADJUSTMENT"] = "adjustment";
    DisputeTransactionType["DISPUTE"] = "dispute";
})(DisputeTransactionType = exports.DisputeTransactionType || (exports.DisputeTransactionType = {}));
var DisputeType;
(function (DisputeType) {
    DisputeType["CHARGEBACK"] = "chargeback";
})(DisputeType = exports.DisputeType || (exports.DisputeType = {}));
var DutyCompoundExpressionType;
(function (DutyCompoundExpressionType) {
    DutyCompoundExpressionType["SUM"] = "sum";
    DutyCompoundExpressionType["MAX"] = "max";
    DutyCompoundExpressionType["MIN"] = "min";
})(DutyCompoundExpressionType = exports.DutyCompoundExpressionType || (exports.DutyCompoundExpressionType = {}));
var DutyExemptItemTypes;
(function (DutyExemptItemTypes) {
    DutyExemptItemTypes["GIFT_CARD"] = "gift_card";
    DutyExemptItemTypes["SERVICE"] = "service";
    DutyExemptItemTypes["DIGITAL_ITEM"] = "digital_item";
    DutyExemptItemTypes["PERSONALIZATION"] = "personalization";
})(DutyExemptItemTypes = exports.DutyExemptItemTypes || (exports.DutyExemptItemTypes = {}));
var DutyRateSource;
(function (DutyRateSource) {
    DutyRateSource["TARIFF_CODE_RATE"] = "tariff_code_rate";
    DutyRateSource["COMPOUND_RATE"] = "compound_rate";
    DutyRateSource["CSV_FALLBACK_RATE"] = "csv_fallback_rate";
    DutyRateSource["HARDCODED_RATE"] = "hardcoded_rate";
})(DutyRateSource = exports.DutyRateSource || (exports.DutyRateSource = {}));
var DutyRateUnitOfMeasure;
(function (DutyRateUnitOfMeasure) {
    DutyRateUnitOfMeasure["KG"] = "kg";
    DutyRateUnitOfMeasure["SQ_M"] = "sq m";
    DutyRateUnitOfMeasure["ITEM"] = "item";
    DutyRateUnitOfMeasure["PAIR"] = "pair";
})(DutyRateUnitOfMeasure = exports.DutyRateUnitOfMeasure || (exports.DutyRateUnitOfMeasure = {}));
var DutySelectionRule;
(function (DutySelectionRule) {
    DutySelectionRule["LOOKUP_BY_TARIFF_CODE"] = "lookup_by_tariff_code";
    DutySelectionRule["LOOKUP_BY_HS_6_CODE"] = "lookup_by_hs6_code";
    DutySelectionRule["FALLBACK_FOR_JURISDICTION"] = "fallback_for_jurisdiction";
    DutySelectionRule["DOMESTIC_SALE"] = "domestic_sale";
    DutySelectionRule["INTRA_COMMUNITY_SALE"] = "intra_community_sale";
    DutySelectionRule["REIMPORT"] = "reimport";
    DutySelectionRule["OVERRIDE"] = "override";
    DutySelectionRule["PREFERENTIAL_RATE"] = "preferential_rate";
})(DutySelectionRule = exports.DutySelectionRule || (exports.DutySelectionRule = {}));
var DutySimpleExpressionType;
(function (DutySimpleExpressionType) {
    DutySimpleExpressionType["FREE"] = "free";
    DutySimpleExpressionType["PERCENT"] = "percent";
    DutySimpleExpressionType["PER_UOM"] = "per_uom";
    DutySimpleExpressionType["FLAT"] = "flat";
})(DutySimpleExpressionType = exports.DutySimpleExpressionType || (exports.DutySimpleExpressionType = {}));
var DutyTransactionType;
(function (DutyTransactionType) {
    DutyTransactionType["ADJUSTMENT"] = "adjustment";
    DutyTransactionType["REVERSAL"] = "reversal";
    DutyTransactionType["DUTY"] = "duty";
})(DutyTransactionType = exports.DutyTransactionType || (exports.DutyTransactionType = {}));
var EmptyAttribute;
(function (EmptyAttribute) {
    EmptyAttribute["IRRELEVANT"] = "irrelevant";
})(EmptyAttribute = exports.EmptyAttribute || (exports.EmptyAttribute = {}));
var ErpFileType;
(function (ErpFileType) {
    ErpFileType["VENDOR"] = "vendor";
})(ErpFileType = exports.ErpFileType || (exports.ErpFileType = {}));
var EventType;
(function (EventType) {
    EventType["ADJUSTED_ESTIMATES_UPSERTED"] = "adjusted_estimates_upserted";
    EventType["ADJUSTED_ESTIMATES_DELETED"] = "adjusted_estimates_deleted";
    EventType["FINAL_ESTIMATE_UPSERTED"] = "final_estimate_upserted";
    EventType["FINAL_ESTIMATE_DELETED"] = "final_estimate_deleted";
    EventType["ADYEN_AUTHORIZATION_DELETED"] = "adyen_authorization_deleted";
    EventType["ADYEN_AUTHORIZATION_UPSERTED"] = "adyen_authorization_upserted";
    EventType["ADYEN_CANCEL_DELETED"] = "adyen_cancel_deleted";
    EventType["ADYEN_CANCEL_UPSERTED"] = "adyen_cancel_upserted";
    EventType["ADYEN_CAPTURE_DELETED"] = "adyen_capture_deleted";
    EventType["ADYEN_CAPTURE_UPSERTED"] = "adyen_capture_upserted";
    EventType["ADYEN_REFUND_DELETED"] = "adyen_refund_deleted";
    EventType["ADYEN_REFUND_UPSERTED"] = "adyen_refund_upserted";
    EventType["ADYEN_DISPUTE_UPSERTED"] = "adyen_dispute_upserted";
    EventType["ADYEN_DISPUTE_DELETED"] = "adyen_dispute_deleted";
    EventType["FULFILLMENT_UPSERTED"] = "fulfillment_upserted";
    EventType["FULFILLMENT_DELETED"] = "fulfillment_deleted";
    EventType["MERCHANT_UPSERTED"] = "merchant_upserted";
    EventType["MERCHANT_DELETED"] = "merchant_deleted";
    EventType["ACCOUNT_UPSERTED"] = "account_upserted";
    EventType["ACCOUNT_UPSERTED_V_2"] = "account_upserted_v2";
    EventType["ACCOUNT_DELETED_V_2"] = "account_deleted_v2";
    EventType["ACCOUNT_CONTACT_UPSERTED"] = "account_contact_upserted";
    EventType["ACCOUNT_CONTACT_DELETED"] = "account_contact_deleted";
    EventType["BILLING_STATEMENT_UPSERTED"] = "billing_statement_upserted";
    EventType["BILLING_STATEMENT_DELETED"] = "billing_statement_deleted";
    EventType["TAX_REMITTANCE_TRANSACTION_UPSERTED"] = "tax_remittance_transaction_upserted";
    EventType["TAX_REMITTANCE_TRANSACTION_DELETED"] = "tax_remittance_transaction_deleted";
    EventType["CHANNEL_ACCOUNT_UPSERTED_V_2"] = "channel_account_upserted_v2";
    EventType["CHANNEL_ACCOUNT_DELETED"] = "channel_account_deleted";
    EventType["ORGANIZATION_ACCOUNT_UPSERTED_V_2"] = "organization_account_upserted_v2";
    EventType["ORGANIZATION_ACCOUNT_DELETED"] = "organization_account_deleted";
    EventType["ACCOUNT_TRANSACTIONS_EXPORT_REQUEST"] = "account_transactions_export_request";
    EventType["ACCOUNT_ORDERS_EXPORT_REQUEST"] = "account_orders_export_request";
    EventType["MAIN_TRANSACTION_UPSERTED"] = "main_transaction_upserted";
    EventType["MAIN_TRANSACTION_DELETED"] = "main_transaction_deleted";
    EventType["MAIN_TRANSACTION_UPSERTED_V_2"] = "main_transaction_upserted_v2";
    EventType["MAIN_TRANSACTION_DELETED_V_2"] = "main_transaction_deleted_v2";
    EventType["TRANSFER_TRANSACTION_UPSERTED"] = "transfer_transaction_upserted";
    EventType["TRANSFER_TRANSACTION_DELETED"] = "transfer_transaction_deleted";
    EventType["TRANSFER_TRANSACTION_UPSERTED_V_2"] = "transfer_transaction_upserted_v2";
    EventType["TRANSFER_TRANSACTION_DELETED_V_2"] = "transfer_transaction_deleted_v2";
    EventType["PROCESSING_TRANSACTION_UPSERTED"] = "processing_transaction_upserted";
    EventType["PROCESSING_TRANSACTION_DELETED"] = "processing_transaction_deleted";
    EventType["BANK_PAYMENT_UPSERTED"] = "bank_payment_upserted";
    EventType["BANK_PAYMENT_UPSERTED_V_2"] = "bank_payment_upserted_v2";
    EventType["BANK_PAYMENT_DELETED_V_2"] = "bank_payment_deleted_v2";
    EventType["CHANNEL_TRANSACTION_UPSERTED"] = "channel_transaction_upserted";
    EventType["CHANNEL_TRANSACTION_DELETED"] = "channel_transaction_deleted";
    EventType["ORDER_TRANSACTION_UPSERTED"] = "order_transaction_upserted";
    EventType["ORDER_TRANSACTION_DELETED"] = "order_transaction_deleted";
    EventType["LABEL_TRANSACTION_UPSERTED"] = "label_transaction_upserted";
    EventType["LABEL_TRANSACTION_DELETED"] = "label_transaction_deleted";
    EventType["CHANNEL_BILLED_TRANSACTION_UPSERTED"] = "channel_billed_transaction_upserted";
    EventType["CHANNEL_BILLED_TRANSACTION_DELETED"] = "channel_billed_transaction_deleted";
    EventType["TAX_TRANSACTION_UPSERTED"] = "tax_transaction_upserted";
    EventType["TAX_TRANSACTION_DELETED"] = "tax_transaction_deleted";
    EventType["DUTY_TRANSACTION_UPSERTED"] = "duty_transaction_upserted";
    EventType["DUTY_TRANSACTION_DELETED"] = "duty_transaction_deleted";
    EventType["TRANSACTION_STATEMENT_UPSERTED"] = "transaction_statement_upserted";
    EventType["TRANSACTION_STATEMENT_DELETED"] = "transaction_statement_deleted";
    EventType["DAILY_VALUE_UPSERTED"] = "daily_value_upserted";
    EventType["DAILY_VALUE_DELETED"] = "daily_value_deleted";
    EventType["REVENUE_RECORD_UPSERTED"] = "revenue_record_upserted";
    EventType["REVENUE_RECORD_DELETED"] = "revenue_record_deleted";
    EventType["OTHER_RECORD_UPSERTED"] = "other_record_upserted";
    EventType["OTHER_RECORD_DELETED"] = "other_record_deleted";
    EventType["CALCULATOR_ORGANIZATION_SETTINGS_UPSERTED"] = "calculator_organization_settings_upserted";
    EventType["CALCULATOR_ORGANIZATION_SETTINGS_DELETED"] = "calculator_organization_settings_deleted";
    EventType["CARRIER_ACCOUNT_UPSERTED_V_2"] = "carrier_account_upserted_v2";
    EventType["CARRIER_ACCOUNT_DELETED"] = "carrier_account_deleted";
    EventType["LABEL_GENERATION_SETTINGS_UPSERTED"] = "label_generation_settings_upserted";
    EventType["LABEL_GENERATION_SETTINGS_DELETED"] = "label_generation_settings_deleted";
    EventType["CATALOG_IMPORT_REQUEST"] = "catalog_import_request";
    EventType["EXCLUSION_RULE_UPSERTED"] = "exclusion_rule_upserted";
    EventType["EXCLUSION_RULE_DELETED"] = "exclusion_rule_deleted";
    EventType["EXCLUSION_RULE_EXPORT_REQUEST"] = "exclusion_rule_export_request";
    EventType["CATALOG_ITEM_REGION_AVAILABILITIES_PUBLISHED"] = "catalog_item_region_availabilities_published";
    EventType["RETURN_POLICY_UPSERTED"] = "return_policy_upserted";
    EventType["RETURN_POLICY_DELETED"] = "return_policy_deleted";
    EventType["RETURN_POLICY_ITEM_RESULT_UPSERTED"] = "return_policy_item_result_upserted";
    EventType["RETURN_POLICY_ITEM_RESULT_DELETED"] = "return_policy_item_result_deleted";
    EventType["CATALOG_SETTINGS_UPSERTED"] = "catalog_settings_upserted";
    EventType["CATALOG_SETTINGS_DELETED"] = "catalog_settings_deleted";
    EventType["CHANNEL_ORDER_ACCEPTANCE_UPSERTED"] = "channel_order_acceptance_upserted";
    EventType["CHANNEL_ORDER_ACCEPTANCE_DELETED"] = "channel_order_acceptance_deleted";
    EventType["CHANNEL_ORDER_ACCEPTANCE_FAILED"] = "channel_order_acceptance_failed";
    EventType["CHECKOUT_CONFIGURATION_UPSERTED"] = "checkout_configuration_upserted";
    EventType["CHECKOUT_CONFIGURATION_DELETED"] = "checkout_configuration_deleted";
    EventType["COMMERCIAL_INVOICE_INTERNAL_UPSERTED"] = "commercial_invoice_internal_upserted";
    EventType["COMMERCIAL_INVOICE_INTERNAL_DELETED"] = "commercial_invoice_internal_deleted";
    EventType["LOCALIZED_CONTENT_UPSERTED"] = "localized_content_upserted";
    EventType["LOCALIZATION_UPSERTED"] = "localization_upserted";
    EventType["INTERNAL_CHANNEL_RATE_DELETED"] = "internal_channel_rate_deleted";
    EventType["INTERNAL_CHANNEL_RATE_UPSERTED"] = "internal_channel_rate_upserted";
    EventType["RATE_DELETED"] = "rate_deleted";
    EventType["RATE_UPSERTED"] = "rate_upserted";
    EventType["SPOT_RATE_DELETED"] = "spot_rate_deleted";
    EventType["SPOT_RATE_UPSERTED"] = "spot_rate_upserted";
    EventType["USD_SPOT_RATE_DELETED"] = "usd_spot_rate_deleted";
    EventType["USD_SPOT_RATE_UPSERTED"] = "usd_spot_rate_upserted";
    EventType["RATE_DELETED_V_2"] = "rate_deleted_v2";
    EventType["RATE_UPSERTED_V_2"] = "rate_upserted_v2";
    EventType["ORGANIZATION_CURRENCY_SETTING_UPSERTED"] = "organization_currency_setting_upserted";
    EventType["ORGANIZATION_CURRENCY_SETTING_DELETED"] = "organization_currency_setting_deleted";
    EventType["CHANNEL_CURRENCY_SETTING_UPSERTED"] = "channel_currency_setting_upserted";
    EventType["CHANNEL_CURRENCY_SETTING_DELETED"] = "channel_currency_setting_deleted";
    EventType["CUSTOMER_PURGE_UPSERTED"] = "customer_purge_upserted";
    EventType["CUSTOMS_DESCRIPTION_IMPORT"] = "customs_description_import";
    EventType["CUSTOMS_DESCRIPTION_TARIFFS_IMPORT"] = "customs_description_tariffs_import";
    EventType["DISPUTE_UPSERTED"] = "dispute_upserted";
    EventType["DISPUTE_DELETED"] = "dispute_deleted";
    EventType["DUTY_RATES_PUBLISHED_V_2"] = "duty_rates_published_v2";
    EventType["ITEM_SALES_MARGIN_DELETED"] = "item_sales_margin_deleted";
    EventType["ITEM_SALES_MARGIN_UPSERTED"] = "item_sales_margin_upserted";
    EventType["ORDER_ATTRIBUTE_DELETED"] = "order_attribute_deleted";
    EventType["ORDER_ATTRIBUTE_UPSERTED"] = "order_attribute_upserted";
    EventType["EXPERIENCE_EXPORT_REQUEST"] = "experience_export_request";
    EventType["EXPERIENCE_IMPORT_REQUEST"] = "experience_import_request";
    EventType["SUBMITTED_ORDER_UPSERTED"] = "submitted_order_upserted";
    EventType["LEVY_RATE_SUMMARY_UPSERTED"] = "levy_rate_summary_upserted";
    EventType["EXPORT_COMPLETED"] = "export_completed";
    EventType["EXPORT_FAILED"] = "export_failed";
    EventType["FEATURE_UPSERTED"] = "feature_upserted";
    EventType["FEATURE_DELETED"] = "feature_deleted";
    EventType["ORGANIZATION_BOOLEAN_VALUE_UPSERTED"] = "organization_boolean_value_upserted";
    EventType["ORGANIZATION_BOOLEAN_VALUE_DELETED"] = "organization_boolean_value_deleted";
    EventType["ACCOUNT_SETTINGS_UPSERTED"] = "account_settings_upserted";
    EventType["ACCOUNT_SETTINGS_DELETED"] = "account_settings_deleted";
    EventType["ACCOUNT_PROCESSING_RATES_UPSERTED"] = "account_processing_rates_upserted";
    EventType["ACCOUNT_PROCESSING_RATES_DELETED"] = "account_processing_rates_deleted";
    EventType["BILLING_ORGANIZATION_PROCESSING_RATES_UPSERTED"] = "billing_organization_processing_rates_upserted";
    EventType["BILLING_ORGANIZATION_PROCESSING_RATES_DELETED"] = "billing_organization_processing_rates_deleted";
    EventType["BILLING_ORGANIZATION_SETTINGS_UPSERTED"] = "billing_organization_settings_upserted";
    EventType["BILLING_ORGANIZATION_SETTINGS_DELETED"] = "billing_organization_settings_deleted";
    EventType["STANDALONE_ATTACHMENT_UPSERTED"] = "standalone_attachment_upserted";
    EventType["STANDALONE_ATTACHMENT_DELETED"] = "standalone_attachment_deleted";
    EventType["PLATFORM_FEE_CHANGE_UPSERTED"] = "platform_fee_change_upserted";
    EventType["PLATFORM_FEE_CHANGE_DELETED"] = "platform_fee_change_deleted";
    EventType["ORGANIZATION_BANK_ACCOUNT_UPSERTED"] = "organization_bank_account_upserted";
    EventType["ORGANIZATION_BANK_ACCOUNT_DELETED"] = "organization_bank_account_deleted";
    EventType["BILLING_CSV_TRANSACTION_UPSERTED"] = "billing_csv_transaction_upserted";
    EventType["BILLING_CSV_TRANSACTION_DELETED"] = "billing_csv_transaction_deleted";
    EventType["LABEL_INVOICE_REQUEST_UPSERTED"] = "label_invoice_request_upserted";
    EventType["LABEL_INVOICE_REQUEST_DELETED"] = "label_invoice_request_deleted";
    EventType["CARRIER_CHARGE_UPSERTED"] = "carrier_charge_upserted";
    EventType["CARRIER_CHARGE_DELETED"] = "carrier_charge_deleted";
    EventType["BANK_PAYMENT_ORDER_UPSERTED"] = "bank_payment_order_upserted";
    EventType["BANK_PAYMENT_ORDER_DELETED"] = "bank_payment_order_deleted";
    EventType["FRAUD_REVIEW_UPSERTED"] = "fraud_review_upserted";
    EventType["FRAUD_REVIEW_DELETED"] = "fraud_review_deleted";
    EventType["FRAUD_PENDING_REVIEW_UPSERTED"] = "fraud_pending_review_upserted";
    EventType["FRAUD_PENDING_REVIEW_DELETED"] = "fraud_pending_review_deleted";
    EventType["FRAUD_REVIEW_DECISION_UPSERTED"] = "fraud_review_decision_upserted";
    EventType["FRAUD_REVIEW_DECISION_DELETED"] = "fraud_review_decision_deleted";
    EventType["FRAUD_REVIEW_AUTHORIZATION_UPSERTED"] = "fraud_review_authorization_upserted";
    EventType["FRAUD_REVIEW_AUTHORIZATION_DELETED"] = "fraud_review_authorization_deleted";
    EventType["FRAUD_PENDING_REVIEW_AUTHORIZATION_UPSERTED"] = "fraud_pending_review_authorization_upserted";
    EventType["FRAUD_PENDING_REVIEW_AUTHORIZATION_DELETED"] = "fraud_pending_review_authorization_deleted";
    EventType["FRAUD_REVIEW_AUTHORIZATION_DECISION_UPSERTED"] = "fraud_review_authorization_decision_upserted";
    EventType["FRAUD_REVIEW_AUTHORIZATION_DECISION_DELETED"] = "fraud_review_authorization_decision_deleted";
    EventType["FRAUD_PROVIDER_CONFIGURATION_UPSERTED"] = "fraud_provider_configuration_upserted";
    EventType["FRAUD_PROVIDER_CONFIGURATION_DELETED"] = "fraud_provider_configuration_deleted";
    EventType["MANUAL_REVIEW_RULE_UPSERTED"] = "manual_review_rule_upserted";
    EventType["MANUAL_REVIEW_RULE_DELETED"] = "manual_review_rule_deleted";
    EventType["FTP_FILE_UPSERTED"] = "ftp_file_upserted";
    EventType["FTP_FILE_DELETED"] = "ftp_file_deleted";
    EventType["FTP_FILE_TO_PROCESS_UPLOADED"] = "ftp_file_to_process_uploaded";
    EventType["CENTER_DEFAULTS_UPSERTED"] = "center_defaults_upserted";
    EventType["CENTER_DEFAULTS_DELETED"] = "center_defaults_deleted";
    EventType["FULFILLMENT_FALLBACKS_UPSERTED"] = "fulfillment_fallbacks_upserted";
    EventType["FULFILLMENT_FALLBACKS_DELETED"] = "fulfillment_fallbacks_deleted";
    EventType["PREGENERATED_REQUEST_EVENT"] = "pregenerated_request_event";
    EventType["QUOTE_UPSERTED"] = "quote_upserted";
    EventType["QUOTE_DELETED"] = "quote_deleted";
    EventType["ALL_ITEMS_EXPORT"] = "all_items_export";
    EventType["HARMONIZED_ITEMS_HS_6_EXPORT"] = "harmonized_items_hs6_export";
    EventType["UNHARMONIZED_ITEMS_EXPORT"] = "unharmonized_items_export";
    EventType["DUTIED_ITEMS_EXPORT"] = "dutied_items_export";
    EventType["HARMONIZATION_PHRASE_SUGGESTION_REQUEST_IMPORT"] = "harmonization_phrase_suggestion_request_import";
    EventType["HARMONIZATION_CODES_IMPORT"] = "harmonization_codes_import";
    EventType["ITEM_CLASSIFICATION_CREATED"] = "item_classification_created";
    EventType["HARMONIZE_FULLY_REQUEST_V_2"] = "harmonize_fully_request_v2";
    EventType["IMPORT_COMPLETED"] = "import_completed";
    EventType["IMPORT_FAILED"] = "import_failed";
    EventType["TIME_TO_CLASSIFY_UPSERTED"] = "time_to_classify_upserted";
    EventType["TIME_TO_CLASSIFY_DELETED"] = "time_to_classify_deleted";
    EventType["TIME_TO_CLASSIFY_AGGREGATED_UPSERTED"] = "time_to_classify_aggregated_upserted";
    EventType["TIME_TO_CLASSIFY_AGGREGATED_DELETED"] = "time_to_classify_aggregated_deleted";
    EventType["RATE_SOURCE_SUMMARY_UPSERTED"] = "rate_source_summary_upserted";
    EventType["RATE_SOURCE_SUMMARY_DELETED"] = "rate_source_summary_deleted";
    EventType["RATE_FRESHNESS_SUMMARY_UPSERTED"] = "rate_freshness_summary_upserted";
    EventType["RATE_FRESHNESS_SUMMARY_DELETED"] = "rate_freshness_summary_deleted";
    EventType["ITEM_HARMONIZATION_UPSERTED"] = "item_harmonization_upserted";
    EventType["ITEM_HARMONIZATION_DELETED"] = "item_harmonization_deleted";
    EventType["HARMONIZATION_CLASSIFICATION_STATISTICS_PUBLISHED"] = "harmonization_classification_statistics_published";
    EventType["ISSUER_UPSERTED"] = "issuer_upserted";
    EventType["ISSUER_DELETED"] = "issuer_deleted";
    EventType["ITEM_FORM_IMPORT_REQUEST"] = "item_form_import_request";
    EventType["LABEL_REQUEST_ERROR_UPSERTED"] = "label_request_error_upserted";
    EventType["LABEL_REQUEST_ERROR_DELETED"] = "label_request_error_deleted";
    EventType["ORDER_VALIDATION_FAILURE_UPSERTED"] = "order_validation_failure_upserted";
    EventType["ORDER_VALIDATION_FAILURE_DELETED"] = "order_validation_failure_deleted";
    EventType["ORDER_VALIDATION_UPSERTED"] = "order_validation_upserted";
    EventType["ORDER_VALIDATION_DELETED"] = "order_validation_deleted";
    EventType["LABEL_TRACKING_SUMMARY_UPSERTED"] = "label_tracking_summary_upserted";
    EventType["LABEL_TRACKING_SUMMARY_DELETED"] = "label_tracking_summary_deleted";
    EventType["LOGISTICS_CAPABILITIES_UPSERTED"] = "logistics_capabilities_upserted";
    EventType["LOGISTICS_CAPABILITIES_DELETED"] = "logistics_capabilities_deleted";
    EventType["LOCALIZED_ITEM_PRICES_EXPORT_REQUEST"] = "localized_item_prices_export_request";
    EventType["OPTIN_PROMPT_UPSERTED"] = "optin_prompt_upserted";
    EventType["OPTIN_PROMPT_DELETED"] = "optin_prompt_deleted";
    EventType["ORDER_COMBINED_SHIPMENT_UPSERTED"] = "order_combined_shipment_upserted";
    EventType["ORDER_COMBINED_SHIPMENT_DELETED"] = "order_combined_shipment_deleted";
    EventType["ORDER_FULFILLMENT_DELETED"] = "order_fulfillment_deleted";
    EventType["ORDER_FULFILLMENT_UPSERTED"] = "order_fulfillment_upserted";
    EventType["ORDER_PLACED"] = "order_placed";
    EventType["READY_TO_FULFILL"] = "ready_to_fulfill";
    EventType["FULFILLMENT_CANCEL"] = "fulfillment_cancel";
    EventType["ORDER_SHIPPED"] = "order_shipped";
    EventType["ITEMS_SHIPPED"] = "items_shipped";
    EventType["ORGANIZATION_BUSINESS_ENTITY_DELETED"] = "organization_business_entity_deleted";
    EventType["ORGANIZATION_BUSINESS_ENTITY_UPSERTED"] = "organization_business_entity_upserted";
    EventType["ORGANIZATION_STATUS_CHANGE_UPSERTED"] = "organization_status_change_upserted";
    EventType["ORGANIZATION_STATUS_CHANGE_DELETED"] = "organization_status_change_deleted";
    EventType["ORGANIZATION_DEACTIVATION_UPSERTED"] = "organization_deactivation_upserted";
    EventType["ORGANIZATION_DEACTIVATION_DELETED"] = "organization_deactivation_deleted";
    EventType["MERCHANT_GUID_ASSIGNMENT_UPSERTED"] = "merchant_guid_assignment_upserted";
    EventType["MERCHANT_GUID_ASSIGNMENT_DELETED"] = "merchant_guid_assignment_deleted";
    EventType["ORGANIZATION_METADATA_UPSERTED"] = "organization_metadata_upserted";
    EventType["ORGANIZATION_METADATA_DELETED"] = "organization_metadata_deleted";
    EventType["PARTNER_ORGANIZATION_SETTINGS_UPSERTED"] = "partner_organization_settings_upserted";
    EventType["PARTNER_ORGANIZATION_SETTINGS_DELETED"] = "partner_organization_settings_deleted";
    EventType["UNASSIGNED_MERCHANT_GUID_UPSERTED"] = "unassigned_merchant_guid_upserted";
    EventType["UNASSIGNED_MERCHANT_GUID_DELETED"] = "unassigned_merchant_guid_deleted";
    EventType["PARTNER_TRACKING_SUBSCRIPTION_UPSERTED"] = "partner_tracking_subscription_upserted";
    EventType["PARTNER_TRACKING_SUBSCRIPTION_DELETED"] = "partner_tracking_subscription_deleted";
    EventType["SPP_TRACKER_UPDATE_REQUEST_UPSERTED"] = "spp_tracker_update_request_upserted";
    EventType["SPP_TRACKER_UPDATE_REQUEST_DELETED"] = "spp_tracker_update_request_deleted";
    EventType["INTERNAL_AUTHORIZATION_UPSERTED"] = "internal_authorization_upserted";
    EventType["INTERNAL_AUTHORIZATION_DELETED"] = "internal_authorization_deleted";
    EventType["AFTERPAY_AUTHORIZATION_UPSERTED"] = "afterpay_authorization_upserted";
    EventType["AFTERPAY_AUTHORIZATION_DELETED"] = "afterpay_authorization_deleted";
    EventType["AFTERPAY_CAPTURE_UPSERTED"] = "afterpay_capture_upserted";
    EventType["AFTERPAY_CAPTURE_DELETED"] = "afterpay_capture_deleted";
    EventType["AFTERPAY_REFUND_UPSERTED"] = "afterpay_refund_upserted";
    EventType["AFTERPAY_REFUND_DELETED"] = "afterpay_refund_deleted";
    EventType["ADYEN_MERCHANT_ACCOUNT_UPSERTED"] = "adyen_merchant_account_upserted";
    EventType["ADYEN_MERCHANT_ACCOUNT_DELETED"] = "adyen_merchant_account_deleted";
    EventType["CHARGEBACK_UPSERTED"] = "chargeback_upserted";
    EventType["CHARGEBACK_DELETED"] = "chargeback_deleted";
    EventType["PAYMENT_PROCESSOR_ACCOUNT_UPSERTED"] = "payment_processor_account_upserted";
    EventType["PAYMENT_PROCESSOR_ACCOUNT_DELETED"] = "payment_processor_account_deleted";
    EventType["PAYMENT_PROCESSOR_MERCHANT_UPSERTED"] = "payment_processor_merchant_upserted";
    EventType["PAYMENT_PROCESSOR_MERCHANT_DELETED"] = "payment_processor_merchant_deleted";
    EventType["AUTHORIZATION_BUNDLE_UPSERTED"] = "authorization_bundle_upserted";
    EventType["AUTHORIZATION_BUNDLE_DELETED"] = "authorization_bundle_deleted";
    EventType["ORGANIZATION_PAYMENT_SETTING_UPSERTED"] = "organization_payment_setting_upserted";
    EventType["ORGANIZATION_PAYMENT_SETTING_DELETED"] = "organization_payment_setting_deleted";
    EventType["PAYPAL_PAYMENT_DELETED"] = "paypal_payment_deleted";
    EventType["PAYPAL_PAYMENT_UPSERTED"] = "paypal_payment_upserted";
    EventType["PAYPAL_EXECUTION_DELETED"] = "paypal_execution_deleted";
    EventType["PAYPAL_EXECUTION_UPSERTED"] = "paypal_execution_upserted";
    EventType["PAYPAL_REFUND_DELETED"] = "paypal_refund_deleted";
    EventType["PAYPAL_REFUND_UPSERTED"] = "paypal_refund_upserted";
    EventType["PAYPAL_DISPUTE_UPSERTED"] = "paypal_dispute_upserted";
    EventType["PAYPAL_DISPUTE_DELETED"] = "paypal_dispute_deleted";
    EventType["PRODUCT_RESTRICTION_RULE_DECISION_UPSERTED"] = "product_restriction_rule_decision_upserted";
    EventType["PRODUCT_RESTRICTION_RULE_DECISION_DELETED"] = "product_restriction_rule_decision_deleted";
    EventType["ORDER_RATES_PUBLISHED_V_3"] = "order_rates_published_v3";
    EventType["RATECARD_DIMENSION_ESTIMATE_UPSERTED"] = "ratecard_dimension_estimate_upserted";
    EventType["RATECARD_DIMENSION_ESTIMATE_DELETED"] = "ratecard_dimension_estimate_deleted";
    EventType["RATECARD_LANES_IMPORT_REQUEST"] = "ratecard_lanes_import_request";
    EventType["RATECARD_STANDARD_CONFIGURATION_UPSERTED"] = "ratecard_standard_configuration_upserted";
    EventType["RATECARD_STANDARD_CONFIGURATION_DELETED"] = "ratecard_standard_configuration_deleted";
    EventType["RATECARD_SERVICE_FEE_UPSERTED"] = "ratecard_service_fee_upserted";
    EventType["RATECARD_SERVICE_FEE_DELETED"] = "ratecard_service_fee_deleted";
    EventType["RATECARD_LANE_AGGREGATE_UPSERTED"] = "ratecard_lane_aggregate_upserted";
    EventType["RATECARD_LANE_AGGREGATE_DELETED"] = "ratecard_lane_aggregate_deleted";
    EventType["RATECARD_RATE_LEVEL_UPSERTED"] = "ratecard_rate_level_upserted";
    EventType["RATECARD_RATE_LEVEL_DELETED"] = "ratecard_rate_level_deleted";
    EventType["RATECARD_RATE_LEVEL_RATECARD_UPSERTED"] = "ratecard_rate_level_ratecard_upserted";
    EventType["RATECARD_RATE_LEVEL_RATECARD_DELETED"] = "ratecard_rate_level_ratecard_deleted";
    EventType["RATECARD_RATE_LEVEL_ORGANIZATION_UPSERTED"] = "ratecard_rate_level_organization_upserted";
    EventType["RATECARD_RATE_LEVEL_ORGANIZATION_DELETED"] = "ratecard_rate_level_organization_deleted";
    EventType["RESTRICTION_ORGANIZATION_STATUS_UPSERTED"] = "restriction_organization_status_upserted";
    EventType["RESTRICTION_ORGANIZATION_STATUS_DELETED"] = "restriction_organization_status_deleted";
    EventType["ORGANIZATION_RESTRICTION_STATUS_UPSERTED"] = "organization_restriction_status_upserted";
    EventType["ORGANIZATION_RESTRICTION_STATUS_DELETED"] = "organization_restriction_status_deleted";
    EventType["SCREENING_STATUS_CHANGE_UPSERTED"] = "screening_status_change_upserted";
    EventType["SCREENING_STATUS_CHANGE_DELETED"] = "screening_status_change_deleted";
    EventType["RESTRICTIONS_DAILYOPS_UPSERTED"] = "restrictions_dailyops_upserted";
    EventType["RESTRICTIONS_DAILYOPS_DELETED"] = "restrictions_dailyops_deleted";
    EventType["RESTRICTION_RULE_UPSERTED"] = "restriction_rule_upserted";
    EventType["RESTRICTION_RULE_DELETED"] = "restriction_rule_deleted";
    EventType["RESTRICTION_RULE_EFFECT_UPSERTED"] = "restriction_rule_effect_upserted";
    EventType["RESTRICTION_RULE_EFFECT_DELETED"] = "restriction_rule_effect_deleted";
    EventType["SHOPIFY_SHOP_UPSERTED"] = "shopify_shop_upserted";
    EventType["SHOPIFY_SHOP_DELETED"] = "shopify_shop_deleted";
    EventType["SHOPIFY_EXPERIENCE_SHORT_ID_UPSERTED"] = "shopify_experience_short_id_upserted";
    EventType["SHOPIFY_EXPERIENCE_SHORT_ID_DELETED"] = "shopify_experience_short_id_deleted";
    EventType["SHOPIFY_MARKETS_ORDER_UPSERTED"] = "shopify_markets_order_upserted";
    EventType["SHOPIFY_MARKETS_ORDER_DELETED"] = "shopify_markets_order_deleted";
    EventType["SHOPIFY_MARKETS_SHOP_UPSERTED"] = "shopify_markets_shop_upserted";
    EventType["SHOPIFY_MARKETS_SHOP_DELETED"] = "shopify_markets_shop_deleted";
    EventType["SHOPIFY_MARKETS_WEBHOOK_REGISTRATION_UPSERTED"] = "shopify_markets_webhook_registration_upserted";
    EventType["SHOPIFY_MARKETS_WEBHOOK_REGISTRATION_DELETED"] = "shopify_markets_webhook_registration_deleted";
    EventType["SHOPIFY_MARKETS_SHOP_STATISTICS_UPSERTED"] = "shopify_markets_shop_statistics_upserted";
    EventType["SHOPIFY_MARKETS_SHOP_STATISTICS_DELETED"] = "shopify_markets_shop_statistics_deleted";
    EventType["SHOPIFY_MARKETS_METRICS_UPSERTED"] = "shopify_markets_metrics_upserted";
    EventType["SHOPIFY_MARKETS_METRICS_DELETED"] = "shopify_markets_metrics_deleted";
    EventType["CHANNEL_ORDER_SUMMARY_UPSERTED"] = "channel_order_summary_upserted";
    EventType["CHANNEL_ORDER_SUMMARY_DELETED"] = "channel_order_summary_deleted";
    EventType["CHANNEL_ORGANIZATION_IDENTIFIER_UPSERTED"] = "channel_organization_identifier_upserted";
    EventType["CHANNEL_ORGANIZATION_IDENTIFIER_DELETED"] = "channel_organization_identifier_deleted";
    EventType["ORDER_TAX_AND_DUTY_INCLUSIVITY_SETTING_UPSERTED"] = "order_tax_and_duty_inclusivity_setting_upserted";
    EventType["ORDER_TAX_AND_DUTY_INCLUSIVITY_SETTING_DELETED"] = "order_tax_and_duty_inclusivity_setting_deleted";
    EventType["SHOPIFY_PRODUCT_BUNDLE_UPSERTED"] = "shopify_product_bundle_upserted";
    EventType["SHOPIFY_PRODUCT_BUNDLE_DELETED"] = "shopify_product_bundle_deleted";
    EventType["SHOPIFY_INCOTERM_SUMMARY_ERROR_PUBLISHED"] = "shopify_incoterm_summary_error_published";
    EventType["SHOPIFY_MARKETS_BEST_SELLING_PRODUCT_UPSERTED"] = "shopify_markets_best_selling_product_upserted";
    EventType["SHOPIFY_MARKETS_BEST_SELLING_PRODUCT_DELETED"] = "shopify_markets_best_selling_product_deleted";
    EventType["SHOPIFY_PRODUCT_CREATE_UPSERTED"] = "shopify_product_create_upserted";
    EventType["SHOPIFY_PRODUCT_CREATE_DELETED"] = "shopify_product_create_deleted";
    EventType["SHOPIFY_PRODUCT_UPDATE_UPSERTED"] = "shopify_product_update_upserted";
    EventType["SHOPIFY_PRODUCT_UPDATE_DELETED"] = "shopify_product_update_deleted";
    EventType["SHOPIFY_PRODUCT_DELETE_UPSERTED"] = "shopify_product_delete_upserted";
    EventType["SHOPIFY_PRODUCT_DELETE_DELETED"] = "shopify_product_delete_deleted";
    EventType["SHOPIFY_INVENTORY_ITEM_CREATE_UPSERTED"] = "shopify_inventory_item_create_upserted";
    EventType["SHOPIFY_INVENTORY_ITEM_CREATE_DELETED"] = "shopify_inventory_item_create_deleted";
    EventType["SHOPIFY_INVENTORY_ITEM_UPDATE_UPSERTED"] = "shopify_inventory_item_update_upserted";
    EventType["SHOPIFY_INVENTORY_ITEM_UPDATE_DELETED"] = "shopify_inventory_item_update_deleted";
    EventType["SHOPIFY_INVENTORY_ITEM_DELETE_UPSERTED"] = "shopify_inventory_item_delete_upserted";
    EventType["SHOPIFY_INVENTORY_ITEM_DELETE_DELETED"] = "shopify_inventory_item_delete_deleted";
    EventType["SHOPIFY_MONITORING_ORDER_MONITOR_EVENT_UPSERTED"] = "shopify_monitoring_order_monitor_event_upserted";
    EventType["SHOPIFY_MONITORING_ORDER_MONITOR_EVENT_DELETED"] = "shopify_monitoring_order_monitor_event_deleted";
    EventType["SHOPIFY_ORDER_FULFILLMENTS_SNAPSHOT_UPSERTED"] = "shopify_order_fulfillments_snapshot_upserted";
    EventType["SHOPIFY_ORDER_FULFILLMENTS_SNAPSHOT_DELETED"] = "shopify_order_fulfillments_snapshot_deleted";
    EventType["STRIPE_AUTHORIZATION_DELETED"] = "stripe_authorization_deleted";
    EventType["STRIPE_AUTHORIZATION_UPSERTED"] = "stripe_authorization_upserted";
    EventType["STRIPE_REVERSAL_DELETED"] = "stripe_reversal_deleted";
    EventType["STRIPE_REVERSAL_UPSERTED"] = "stripe_reversal_upserted";
    EventType["STRIPE_CAPTURE_DELETED"] = "stripe_capture_deleted";
    EventType["STRIPE_CAPTURE_UPSERTED"] = "stripe_capture_upserted";
    EventType["STRIPE_REFUND_DELETED"] = "stripe_refund_deleted";
    EventType["STRIPE_REFUND_UPSERTED"] = "stripe_refund_upserted";
    EventType["STRIPE_DISPUTE_UPSERTED"] = "stripe_dispute_upserted";
    EventType["STRIPE_DISPUTE_DELETED"] = "stripe_dispute_deleted";
    EventType["LIABILITY_REMITTANCE_PLAN_UPSERTED"] = "liability_remittance_plan_upserted";
    EventType["LIABILITY_REMITTANCE_PLAN_DELETED"] = "liability_remittance_plan_deleted";
    EventType["TRACKING_PROCESSING_ERROR_UPSERTED"] = "tracking_processing_error_upserted";
    EventType["TRACKING_PROCESSING_ERROR_DELETED"] = "tracking_processing_error_deleted";
    EventType["TRACKING_LABEL_EVENT_UPSERTED_V_2"] = "tracking_label_event_upserted_v2";
    EventType["TRACKING_LABEL_EVENT_DELETED_V_2"] = "tracking_label_event_deleted_v2";
    EventType["TRACKING_LABEL_UPSERTED"] = "tracking_label_upserted";
    EventType["TRACKING_LABEL_DELETED"] = "tracking_label_deleted";
    EventType["TRACKING_UPSERTED"] = "tracking_upserted";
    EventType["TRACKING_DELETED"] = "tracking_deleted";
    EventType["TRACKING_ASSURANCE_ANALYSIS_UPSERTED"] = "tracking_assurance_analysis_upserted";
    EventType["TRACKING_ASSURANCE_ANALYSIS_DELETED"] = "tracking_assurance_analysis_deleted";
    EventType["TRACKING_ASSURANCE_JOB_UPSERTED"] = "tracking_assurance_job_upserted";
    EventType["TRACKING_ASSURANCE_JOB_DELETED"] = "tracking_assurance_job_deleted";
    EventType["TRACKING_SUBSCRIPTION_UPSERTED"] = "tracking_subscription_upserted";
    EventType["TRACKING_SUBSCRIPTION_DELETED"] = "tracking_subscription_deleted";
    EventType["TRACKING_CARRIER_RETURN_LABEL_UPSERTED"] = "tracking_carrier_return_label_upserted";
    EventType["TRACKING_CARRIER_RETURN_LABEL_DELETED"] = "tracking_carrier_return_label_deleted";
    EventType["TRACKING_LABEL_DIMENSIONS_UPSERTED"] = "tracking_label_dimensions_upserted";
    EventType["TRACKING_LABEL_DIMENSIONS_DELETED"] = "tracking_label_dimensions_deleted";
    EventType["USER_UPSERTED_V_2"] = "user_upserted_v2";
    EventType["USER_DELETED_V_2"] = "user_deleted_v2";
})(EventType = exports.EventType || (exports.EventType = {}));
var ExperienceImportType;
(function (ExperienceImportType) {
    ExperienceImportType["EXPERIENCE_WITH_SETTINGS"] = "experience_with_settings";
})(ExperienceImportType = exports.ExperienceImportType || (exports.ExperienceImportType = {}));
var ExperienceOrderAction;
(function (ExperienceOrderAction) {
    ExperienceOrderAction["SUBMIT"] = "submit";
    ExperienceOrderAction["REFUND_GIFT_CARDS"] = "refund_gift_cards";
})(ExperienceOrderAction = exports.ExperienceOrderAction || (exports.ExperienceOrderAction = {}));
var ExperienceOrderActionTrigger;
(function (ExperienceOrderActionTrigger) {
    ExperienceOrderActionTrigger["ZERO_BALANCE"] = "zero_balance";
    ExperienceOrderActionTrigger["UNSUBMITTED_ORDER"] = "unsubmitted_order";
})(ExperienceOrderActionTrigger = exports.ExperienceOrderActionTrigger || (exports.ExperienceOrderActionTrigger = {}));
var ExportContentType;
(function (ExportContentType) {
    ExportContentType["ITEM"] = "item";
    ExportContentType["PRICE_BOOK_ITEM"] = "price_book_item";
})(ExportContentType = exports.ExportContentType || (exports.ExportContentType = {}));
var FeatureScope;
(function (FeatureScope) {
    FeatureScope["GLOBAL"] = "global";
    FeatureScope["ORGANIZATION"] = "organization";
})(FeatureScope = exports.FeatureScope || (exports.FeatureScope = {}));
var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["DRAFT"] = "draft";
    FeatureStatus["ACTIVE"] = "active";
    FeatureStatus["ARCHIVED"] = "archived";
})(FeatureStatus = exports.FeatureStatus || (exports.FeatureStatus = {}));
var FeatureType;
(function (FeatureType) {
    FeatureType["BOOLEAN"] = "boolean";
    FeatureType["DECIMAL"] = "decimal";
    FeatureType["STRING"] = "string";
})(FeatureType = exports.FeatureType || (exports.FeatureType = {}));
var FeesSource;
(function (FeesSource) {
    FeesSource["SETTINGS"] = "settings";
    FeesSource["AUTHORIZATION_BUNDLE"] = "authorization_bundle";
})(FeesSource = exports.FeesSource || (exports.FeesSource = {}));
var FinancialReportingResponsibleParty;
(function (FinancialReportingResponsibleParty) {
    FinancialReportingResponsibleParty["FLOW"] = "flow";
    FinancialReportingResponsibleParty["ORGANIZATION"] = "organization";
})(FinancialReportingResponsibleParty = exports.FinancialReportingResponsibleParty || (exports.FinancialReportingResponsibleParty = {}));
var FlowApp;
(function (FlowApp) {
    FlowApp["CONSOLE"] = "console";
})(FlowApp = exports.FlowApp || (exports.FlowApp = {}));
var Format;
(function (Format) {
    Format["TEXT"] = "text";
    Format["PHONE"] = "phone";
    Format["EMAIL"] = "email";
})(Format = exports.Format || (exports.Format = {}));
var FraudProvider;
(function (FraudProvider) {
    FraudProvider["FLOW"] = "flow";
    FraudProvider["FORTER"] = "forter";
    FraudProvider["PAYPAL"] = "paypal";
    FraudProvider["RISKIFIED"] = "riskified";
    FraudProvider["RPS"] = "rps";
    FraudProvider["OTHER"] = "other";
    FraudProvider["NONE"] = "none";
})(FraudProvider = exports.FraudProvider || (exports.FraudProvider = {}));
var FraudProviderStatus;
(function (FraudProviderStatus) {
    FraudProviderStatus["ACTIVE"] = "active";
    FraudProviderStatus["ARCHIVED"] = "archived";
})(FraudProviderStatus = exports.FraudProviderStatus || (exports.FraudProviderStatus = {}));
var FraudReviewResponsibleParty;
(function (FraudReviewResponsibleParty) {
    FraudReviewResponsibleParty["FLOW"] = "flow";
    FraudReviewResponsibleParty["ORGANIZATION"] = "organization";
})(FraudReviewResponsibleParty = exports.FraudReviewResponsibleParty || (exports.FraudReviewResponsibleParty = {}));
var FtpIntent;
(function (FtpIntent) {
    FtpIntent["ORDERS_FROM_FLOW"] = "orders_from_flow";
    FtpIntent["PRICEBOOKS_FROM_FLOW"] = "pricebooks_from_flow";
    FtpIntent["PRICEBOOKS_TO_FLOW"] = "pricebooks_to_flow";
    FtpIntent["CATALOG_TO_FLOW"] = "catalog_to_flow";
    FtpIntent["INVENTORY_TO_FLOW"] = "inventory_to_flow";
})(FtpIntent = exports.FtpIntent || (exports.FtpIntent = {}));
var FtpProtocol;
(function (FtpProtocol) {
    FtpProtocol["SFTP"] = "sftp";
    FtpProtocol["FTP"] = "ftp";
})(FtpProtocol = exports.FtpProtocol || (exports.FtpProtocol = {}));
var GoogleAnalyticsPlugin;
(function (GoogleAnalyticsPlugin) {
    GoogleAnalyticsPlugin["EC"] = "ec";
})(GoogleAnalyticsPlugin = exports.GoogleAnalyticsPlugin || (exports.GoogleAnalyticsPlugin = {}));
var GraphqlServiceTypes;
(function (GraphqlServiceTypes) {
    GraphqlServiceTypes["ORDER_UPDATE_MUTATION"] = "order_update_mutation";
    GraphqlServiceTypes["SHIPPING_ADDRESS_VALIDATION"] = "shipping_address_validation";
    GraphqlServiceTypes["BULK_PUBLICATION_STATUS"] = "bulk_publication_status";
    GraphqlServiceTypes["COUNTRY_CATALOG_SYNC"] = "country_catalog_sync";
    GraphqlServiceTypes["INVENTORY_ITEM"] = "inventory_item";
    GraphqlServiceTypes["PRODUCT_BUNDLE"] = "product_bundle";
    GraphqlServiceTypes["SHOPIFY_LOCATION"] = "shopify_location";
    GraphqlServiceTypes["SHOPIFY_ORDER"] = "shopify_order";
    GraphqlServiceTypes["SYNC_PRODUCT_CATALOG"] = "sync_product_catalog";
    GraphqlServiceTypes["SHOPIFY_WEBHOOK"] = "shopify_webhook";
})(GraphqlServiceTypes = exports.GraphqlServiceTypes || (exports.GraphqlServiceTypes = {}));
var HarmonizationDecisionSource;
(function (HarmonizationDecisionSource) {
    HarmonizationDecisionSource["HUMAN"] = "human";
    HarmonizationDecisionSource["LEGACY_MODEL"] = "legacy_model";
    HarmonizationDecisionSource["ENTERPRISE_MODEL"] = "enterprise_model";
})(HarmonizationDecisionSource = exports.HarmonizationDecisionSource || (exports.HarmonizationDecisionSource = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "get";
    HttpMethod["POST"] = "post";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
var ItemClassificationAction;
(function (ItemClassificationAction) {
    ItemClassificationAction["ACCEPT"] = "ACCEPT";
    ItemClassificationAction["MANUAL"] = "MANUAL";
    ItemClassificationAction["REJECT"] = "REJECT";
})(ItemClassificationAction = exports.ItemClassificationAction || (exports.ItemClassificationAction = {}));
var ItemClassificationStatus;
(function (ItemClassificationStatus) {
    ItemClassificationStatus["UNKNOWN"] = "unknown";
    ItemClassificationStatus["MANUAL"] = "manual";
    ItemClassificationStatus["MANUALLY_ACCEPTED"] = "manually_accepted";
    ItemClassificationStatus["MANUALLY_OVERRIDDEN"] = "manually_overridden";
    ItemClassificationStatus["AUTOMATICALLY_ACCEPTED"] = "automatically_accepted";
    ItemClassificationStatus["PENDING"] = "pending";
})(ItemClassificationStatus = exports.ItemClassificationStatus || (exports.ItemClassificationStatus = {}));
var ItemHarmonizationStatus;
(function (ItemHarmonizationStatus) {
    ItemHarmonizationStatus["WAITING_FOR_CLASSIFICATION"] = "waiting_for_classification";
    ItemHarmonizationStatus["CLASSIFIED"] = "classified";
    ItemHarmonizationStatus["NON_CLASSIFIABLE_NOT_ENOUGH_INFORMATION"] = "non_classifiable_not_enough_information";
    ItemHarmonizationStatus["EXEMPT"] = "exempt";
})(ItemHarmonizationStatus = exports.ItemHarmonizationStatus || (exports.ItemHarmonizationStatus = {}));
var ItemQuantityAction;
(function (ItemQuantityAction) {
    ItemQuantityAction["FULFILLMENT_SHIP"] = "fulfillment_ship";
    ItemQuantityAction["FULFILLMENT_CANCEL"] = "fulfillment_cancel";
    ItemQuantityAction["FULFILLMENT_GENERATE_LABEL"] = "fulfillment_generate_label";
})(ItemQuantityAction = exports.ItemQuantityAction || (exports.ItemQuantityAction = {}));
var ItemType;
(function (ItemType) {
    ItemType["STANDARD"] = "standard";
    ItemType["MULTI_PRODUCT"] = "multi_product";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var KeywordType;
(function (KeywordType) {
    KeywordType["POSITIVE"] = "positive";
    KeywordType["NEGATIVE"] = "negative";
})(KeywordType = exports.KeywordType || (exports.KeywordType = {}));
var LabelBillingStrategy;
(function (LabelBillingStrategy) {
    LabelBillingStrategy["QUOTE"] = "quote";
    LabelBillingStrategy["CARRIER"] = "carrier";
})(LabelBillingStrategy = exports.LabelBillingStrategy || (exports.LabelBillingStrategy = {}));
var LabelCancellationErrorCode;
(function (LabelCancellationErrorCode) {
    LabelCancellationErrorCode["ALREADY_USED"] = "already_used";
    LabelCancellationErrorCode["CARRIER_UNSUPPORTED"] = "carrier_unsupported";
})(LabelCancellationErrorCode = exports.LabelCancellationErrorCode || (exports.LabelCancellationErrorCode = {}));
var LabelCreationStatus;
(function (LabelCreationStatus) {
    LabelCreationStatus["SUCCESS"] = "success";
    LabelCreationStatus["ERROR"] = "error";
    LabelCreationStatus["PENDING"] = "pending";
    LabelCreationStatus["CANCELLED"] = "cancelled";
})(LabelCreationStatus = exports.LabelCreationStatus || (exports.LabelCreationStatus = {}));
var LabelEventMedium;
(function (LabelEventMedium) {
    LabelEventMedium["WEBHOOK"] = "webhook";
    LabelEventMedium["PULL"] = "pull";
    LabelEventMedium["POST"] = "post";
})(LabelEventMedium = exports.LabelEventMedium || (exports.LabelEventMedium = {}));
var LabelEventSource;
(function (LabelEventSource) {
    LabelEventSource["AFTERSHIP"] = "aftership";
    LabelEventSource["CARRIER"] = "carrier";
    LabelEventSource["FLOW"] = "flow";
})(LabelEventSource = exports.LabelEventSource || (exports.LabelEventSource = {}));
var LabelRequestErrorHandlingResponsibility;
(function (LabelRequestErrorHandlingResponsibility) {
    LabelRequestErrorHandlingResponsibility["MERCHANT"] = "merchant";
    LabelRequestErrorHandlingResponsibility["MERCHANT_INTEGRATION"] = "merchant_integration";
    LabelRequestErrorHandlingResponsibility["SHOPIFY_INTEGRATION"] = "shopify_integration";
    LabelRequestErrorHandlingResponsibility["GLOBALE_CX"] = "globale_cx";
    LabelRequestErrorHandlingResponsibility["GLOBALE_ADDRESS_REPAIR"] = "globale_address_repair";
    LabelRequestErrorHandlingResponsibility["MERCHANT_OPERATIONS"] = "merchant_operations";
    LabelRequestErrorHandlingResponsibility["GLOBALE_SYSTEM"] = "globale_system";
    LabelRequestErrorHandlingResponsibility["CARRIER"] = "carrier";
})(LabelRequestErrorHandlingResponsibility = exports.LabelRequestErrorHandlingResponsibility || (exports.LabelRequestErrorHandlingResponsibility = {}));
var LabelRequestResultOrganizationType;
(function (LabelRequestResultOrganizationType) {
    LabelRequestResultOrganizationType["ALL"] = "all";
    LabelRequestResultOrganizationType["LEGACY_PRODUCTION"] = "legacy_production";
    LabelRequestResultOrganizationType["MANAGED_MARKETS_PRODUCTION"] = "managed_markets_production";
    LabelRequestResultOrganizationType["SANDBOX"] = "sandbox";
})(LabelRequestResultOrganizationType = exports.LabelRequestResultOrganizationType || (exports.LabelRequestResultOrganizationType = {}));
var LabelRequestResultState;
(function (LabelRequestResultState) {
    LabelRequestResultState["SUCCESS"] = "success";
    LabelRequestResultState["FAILURE"] = "failure";
})(LabelRequestResultState = exports.LabelRequestResultState || (exports.LabelRequestResultState = {}));
var LabelTransactionType;
(function (LabelTransactionType) {
    LabelTransactionType["ADJUSTMENT"] = "adjustment";
    LabelTransactionType["REVERSAL"] = "reversal";
    LabelTransactionType["BILLABLE_LABEL"] = "billable_label";
    LabelTransactionType["FEE"] = "fee";
    LabelTransactionType["REVENUE_SHARE"] = "revenue_share";
})(LabelTransactionType = exports.LabelTransactionType || (exports.LabelTransactionType = {}));
var LiabilityType;
(function (LiabilityType) {
    LiabilityType["FULL_VALUE_TAX"] = "full_value_tax";
    LiabilityType["LOW_VALUE_GOODS_TAX"] = "low_value_goods_tax";
    LiabilityType["HIGH_VALUE_GOODS_TAX"] = "high_value_goods_tax";
    LiabilityType["DUTIES"] = "duties";
})(LiabilityType = exports.LiabilityType || (exports.LiabilityType = {}));
var LogisticsCapability;
(function (LogisticsCapability) {
    LogisticsCapability["LOGISTICS_ADDRESS_CORRECTION"] = "logistics_address_correction";
})(LogisticsCapability = exports.LogisticsCapability || (exports.LogisticsCapability = {}));
var LogisticsPayoutResolutionMethod;
(function (LogisticsPayoutResolutionMethod) {
    LogisticsPayoutResolutionMethod["ORDER_COMBINED_SHIPMENT"] = "order_combined_shipment";
    LogisticsPayoutResolutionMethod["INTRANSIT_LABEL_EVENT"] = "intransit_label_event";
    LogisticsPayoutResolutionMethod["SHIPPING_NOTIFICATION"] = "shipping_notification";
})(LogisticsPayoutResolutionMethod = exports.LogisticsPayoutResolutionMethod || (exports.LogisticsPayoutResolutionMethod = {}));
var ManualReviewRuleStatus;
(function (ManualReviewRuleStatus) {
    ManualReviewRuleStatus["ACTIVE"] = "active";
    ManualReviewRuleStatus["ARCHIVED"] = "archived";
})(ManualReviewRuleStatus = exports.ManualReviewRuleStatus || (exports.ManualReviewRuleStatus = {}));
var ManualTransactionCategory;
(function (ManualTransactionCategory) {
    ManualTransactionCategory["CANCELLED_ORDER_REFUND"] = "cancelled_order_refund";
    ManualTransactionCategory["CLIENT_ACCEPTED_CHARGEBACK"] = "client_accepted_chargeback";
    ManualTransactionCategory["FEE_REIMBURSEMENT"] = "fee_reimbursement";
    ManualTransactionCategory["PLATFORM_FEE"] = "platform_fee";
    ManualTransactionCategory["SHIPPING_TRUE_UP"] = "shipping_true_up";
    ManualTransactionCategory["TAX_CREDIT"] = "tax_credit";
    ManualTransactionCategory["CARRIER_CREDIT"] = "carrier_credit";
    ManualTransactionCategory["NEGATIVE_BALANCE_GUARANTEE"] = "negative_balance_guarantee";
    ManualTransactionCategory["BANK_PAYMENT_FAILURE"] = "bank_payment_failure";
    ManualTransactionCategory["NON_FRAUD_CHARGEBACK"] = "non_fraud_chargeback";
})(ManualTransactionCategory = exports.ManualTransactionCategory || (exports.ManualTransactionCategory = {}));
var MixedBagWeight;
(function (MixedBagWeight) {
    MixedBagWeight["LEAST_MIXED"] = "0";
    MixedBagWeight["PARTIALLY_MIXED"] = "1";
    MixedBagWeight["MIXED"] = "2";
})(MixedBagWeight = exports.MixedBagWeight || (exports.MixedBagWeight = {}));
var NatureOfSale;
(function (NatureOfSale) {
    NatureOfSale["CONSUMER"] = "consumer";
    NatureOfSale["TO_NON_REGISTERED_BUSINESS"] = "to_non_registered_business";
    NatureOfSale["TO_REGISTERED_BUSINESS"] = "to_registered_business";
    NatureOfSale["FLASH_TITLE"] = "flash_title";
})(NatureOfSale = exports.NatureOfSale || (exports.NatureOfSale = {}));
var NoLiabilityReasonCode;
(function (NoLiabilityReasonCode) {
    NoLiabilityReasonCode["ZERO_BASIS"] = "zero_basis";
    NoLiabilityReasonCode["ZERO_RATE_ON_GOODS"] = "zero_rate_on_goods";
    NoLiabilityReasonCode["ZERO_RATE_ON_SALE"] = "zero_rate_on_sale";
    NoLiabilityReasonCode["GOODS_ABOVE_VALUE_THRESHOLD"] = "goods_above_value_threshold";
    NoLiabilityReasonCode["GOODS_BELOW_VALUE_THRESHOLD"] = "goods_below_value_threshold";
    NoLiabilityReasonCode["ORDER_BELOW_DE_MINIMIS_THRESHOLD"] = "order_below_de_minimis_threshold";
    NoLiabilityReasonCode["AMOUNT_BELOW_DE_MINIMIS_THRESHOLD"] = "amount_below_de_minimis_threshold";
    NoLiabilityReasonCode["DELIVERED_UNPAID"] = "delivered_unpaid";
    NoLiabilityReasonCode["DUTY_FREE_DOMESTIC"] = "duty_free_domestic";
    NoLiabilityReasonCode["DUTY_FREE_INTRA_COMMUNITY"] = "duty_free_intra_community";
    NoLiabilityReasonCode["DUTY_FREE_BY_TRADE_AGREEMENT"] = "duty_free_by_trade_agreement";
})(NoLiabilityReasonCode = exports.NoLiabilityReasonCode || (exports.NoLiabilityReasonCode = {}));
var OnboardingAuditMessageLevel;
(function (OnboardingAuditMessageLevel) {
    OnboardingAuditMessageLevel["INFO"] = "info";
    OnboardingAuditMessageLevel["WARNING"] = "warning";
    OnboardingAuditMessageLevel["ERROR"] = "error";
})(OnboardingAuditMessageLevel = exports.OnboardingAuditMessageLevel || (exports.OnboardingAuditMessageLevel = {}));
var OnboardingAuditResult;
(function (OnboardingAuditResult) {
    OnboardingAuditResult["PASS"] = "pass";
    OnboardingAuditResult["WARNING"] = "warning";
    OnboardingAuditResult["FAIL"] = "fail";
})(OnboardingAuditResult = exports.OnboardingAuditResult || (exports.OnboardingAuditResult = {}));
var OnboardingAuditThemeKey;
(function (OnboardingAuditThemeKey) {
    OnboardingAuditThemeKey["BILLING"] = "billing";
    OnboardingAuditThemeKey["B_2_B_INVOICING"] = "b2b_invoicing";
    OnboardingAuditThemeKey["CATALOG"] = "catalog";
    OnboardingAuditThemeKey["CURRENCY"] = "currency";
    OnboardingAuditThemeKey["CHECKOUT"] = "checkout";
    OnboardingAuditThemeKey["FRAUD"] = "fraud";
    OnboardingAuditThemeKey["LOGISTICS"] = "logistics";
    OnboardingAuditThemeKey["PAYMENTS"] = "payments";
    OnboardingAuditThemeKey["SHOPIFY_MARKETS"] = "shopify_markets";
    OnboardingAuditThemeKey["INTEGRATION_PARTNER"] = "integration_partner";
    OnboardingAuditThemeKey["DTCE"] = "dtce";
    OnboardingAuditThemeKey["RESTRICTIONS"] = "restrictions";
    OnboardingAuditThemeKey["ORGANIZATION_STATUS"] = "organization_status";
    OnboardingAuditThemeKey["CATEGORY_CONSTRAINTS"] = "category_constraints";
    OnboardingAuditThemeKey["MISCELLANEOUS"] = "miscellaneous";
})(OnboardingAuditThemeKey = exports.OnboardingAuditThemeKey || (exports.OnboardingAuditThemeKey = {}));
var OnboardingAutomationProcessState;
(function (OnboardingAutomationProcessState) {
    OnboardingAutomationProcessState["NOT_STARTED"] = "not_started";
    OnboardingAutomationProcessState["IN_PROGRESS"] = "in_progress";
    OnboardingAutomationProcessState["SUCCESS"] = "success";
    OnboardingAutomationProcessState["FAILED"] = "failed";
})(OnboardingAutomationProcessState = exports.OnboardingAutomationProcessState || (exports.OnboardingAutomationProcessState = {}));
var OnboardingAutomationTaskState;
(function (OnboardingAutomationTaskState) {
    OnboardingAutomationTaskState["NOT_STARTED"] = "not_started";
    OnboardingAutomationTaskState["IN_PROGRESS"] = "in_progress";
    OnboardingAutomationTaskState["SUCCESS"] = "success";
    OnboardingAutomationTaskState["FAILED"] = "failed";
})(OnboardingAutomationTaskState = exports.OnboardingAutomationTaskState || (exports.OnboardingAutomationTaskState = {}));
var OnboardingStateSource;
(function (OnboardingStateSource) {
    OnboardingStateSource["UNKNOWN"] = "unknown";
    OnboardingStateSource["UNIT_TEST"] = "unit_test";
    OnboardingStateSource["API"] = "api";
    OnboardingStateSource["API_ACTIVATION"] = "api_activation";
    OnboardingStateSource["API_REJECT"] = "api_reject";
    OnboardingStateSource["AUDIT_AUTO_ACTIVATION"] = "audit_auto_activation";
    OnboardingStateSource["API_DEACTIVATION"] = "api_deactivation";
    OnboardingStateSource["API_SANDBOX_SETUP"] = "api_sandbox_setup";
    OnboardingStateSource["API_INTERNAL"] = "api_internal";
    OnboardingStateSource["API_INTERNAL_BLOCK"] = "api_internal_block";
    OnboardingStateSource["API_INTERNAL_UNBLOCK"] = "api_internal_unblock";
    OnboardingStateSource["API_INTERNAL_DELETE_TRANSACTION"] = "api_internal_delete_transaction";
    OnboardingStateSource["ONBOARDING_APPLICATION"] = "onboarding_application";
    OnboardingStateSource["ORGANIZATION_STATE_CHANGE"] = "organization_state_change";
    OnboardingStateSource["RESTRICTION_ORGANIZATION_STATUS"] = "restriction_organization_status";
})(OnboardingStateSource = exports.OnboardingStateSource || (exports.OnboardingStateSource = {}));
var OrderAction;
(function (OrderAction) {
    OrderAction["CONSUMER_SUBMIT"] = "consumer_submit";
    OrderAction["FRAUD_REVIEW_ACCEPT"] = "fraud_review_accept";
    OrderAction["FRAUD_REVIEW_DECLINE"] = "fraud_review_decline";
    OrderAction["PAYMENT_FULLY_AUTHORIZE"] = "payment_fully_authorize";
    OrderAction["PAYMENT_FULLY_CAPTURE"] = "payment_fully_capture";
})(OrderAction = exports.OrderAction || (exports.OrderAction = {}));
var OrderAddressValidationStatus;
(function (OrderAddressValidationStatus) {
    OrderAddressValidationStatus["SUCCESS"] = "success";
    OrderAddressValidationStatus["FAILED"] = "failed";
})(OrderAddressValidationStatus = exports.OrderAddressValidationStatus || (exports.OrderAddressValidationStatus = {}));
var OrderAttributeIntent;
(function (OrderAttributeIntent) {
    OrderAttributeIntent["DISCOUNT_CODE"] = "discount_code";
})(OrderAttributeIntent = exports.OrderAttributeIntent || (exports.OrderAttributeIntent = {}));
var OrderCancellationInitiatedBy;
(function (OrderCancellationInitiatedBy) {
    OrderCancellationInitiatedBy["FLOW"] = "flow";
    OrderCancellationInitiatedBy["ORGANIZATION"] = "organization";
})(OrderCancellationInitiatedBy = exports.OrderCancellationInitiatedBy || (exports.OrderCancellationInitiatedBy = {}));
var OrderChargeTrigger;
(function (OrderChargeTrigger) {
    OrderChargeTrigger["FIRST_SHIPMENT"] = "first_shipment";
    OrderChargeTrigger["LAST_SHIPMENT"] = "last_shipment";
    OrderChargeTrigger["SHIPMENT_EXHAUSTED"] = "shipment_exhausted";
})(OrderChargeTrigger = exports.OrderChargeTrigger || (exports.OrderChargeTrigger = {}));
var OrderLifecycleEvent;
(function (OrderLifecycleEvent) {
    OrderLifecycleEvent["ORDER_PLACED"] = "order_placed";
    OrderLifecycleEvent["READY_TO_FULFILL"] = "ready_to_fulfill";
})(OrderLifecycleEvent = exports.OrderLifecycleEvent || (exports.OrderLifecycleEvent = {}));
var OrderTransactionType;
(function (OrderTransactionType) {
    OrderTransactionType["ADJUSTMENT"] = "adjustment";
    OrderTransactionType["REVERSAL"] = "reversal";
    OrderTransactionType["ORDER_SERVICE"] = "order_service";
})(OrderTransactionType = exports.OrderTransactionType || (exports.OrderTransactionType = {}));
var OrderValidationStatus;
(function (OrderValidationStatus) {
    OrderValidationStatus["SUCCESS"] = "success";
    OrderValidationStatus["FAILED"] = "failed";
    OrderValidationStatus["LABEL_CREATED"] = "label_created";
    OrderValidationStatus["UNRESOLVABLE"] = "unresolvable";
    OrderValidationStatus["CANCELLED"] = "cancelled";
    OrderValidationStatus["BREACHED"] = "breached";
})(OrderValidationStatus = exports.OrderValidationStatus || (exports.OrderValidationStatus = {}));
var OrganizationCapability;
(function (OrganizationCapability) {
    OrganizationCapability["ORGANIZATION"] = "organization";
    OrganizationCapability["FLOW"] = "flow";
    OrganizationCapability["DYNAMIC"] = "dynamic";
})(OrganizationCapability = exports.OrganizationCapability || (exports.OrganizationCapability = {}));
var OrganizationMetricType;
(function (OrganizationMetricType) {
    OrganizationMetricType["ORGANIZATION_RESTRICTION_STATUS"] = "organization_restriction_status";
})(OrganizationMetricType = exports.OrganizationMetricType || (exports.OrganizationMetricType = {}));
var OrganizationPaymentStatus;
(function (OrganizationPaymentStatus) {
    OrganizationPaymentStatus["ACTIVE"] = "active";
    OrganizationPaymentStatus["ARCHIVED"] = "archived";
})(OrganizationPaymentStatus = exports.OrganizationPaymentStatus || (exports.OrganizationPaymentStatus = {}));
var OrganizationRestrictionApprovalStatus;
(function (OrganizationRestrictionApprovalStatus) {
    OrganizationRestrictionApprovalStatus["READY"] = "ready";
    OrganizationRestrictionApprovalStatus["NOT_READY"] = "not-ready";
})(OrganizationRestrictionApprovalStatus = exports.OrganizationRestrictionApprovalStatus || (exports.OrganizationRestrictionApprovalStatus = {}));
var OrganizationRestrictionNoteType;
(function (OrganizationRestrictionNoteType) {
    OrganizationRestrictionNoteType["INTERNAL"] = "internal";
    OrganizationRestrictionNoteType["REJECTION_REASON"] = "rejection_reason";
    OrganizationRestrictionNoteType["ADDITIONAL_REJECTION_INFO"] = "additional_rejection_info";
})(OrganizationRestrictionNoteType = exports.OrganizationRestrictionNoteType || (exports.OrganizationRestrictionNoteType = {}));
var OrganizationRestrictionReviewType;
(function (OrganizationRestrictionReviewType) {
    OrganizationRestrictionReviewType["ALL_PENDING"] = "all_pending";
    OrganizationRestrictionReviewType["PENDING_VERIFICATION"] = "pending_verification";
})(OrganizationRestrictionReviewType = exports.OrganizationRestrictionReviewType || (exports.OrganizationRestrictionReviewType = {}));
var OrganizationRestrictionRiskLevel;
(function (OrganizationRestrictionRiskLevel) {
    OrganizationRestrictionRiskLevel["LOW"] = "5";
    OrganizationRestrictionRiskLevel["HIGH"] = "15";
})(OrganizationRestrictionRiskLevel = exports.OrganizationRestrictionRiskLevel || (exports.OrganizationRestrictionRiskLevel = {}));
var OrganizationRestrictionScreeningStatus;
(function (OrganizationRestrictionScreeningStatus) {
    OrganizationRestrictionScreeningStatus["IN_REVIEW"] = "in_review";
    OrganizationRestrictionScreeningStatus["FULLY_REVIEWED"] = "fully_reviewed";
    OrganizationRestrictionScreeningStatus["REJECTED"] = "rejected";
    OrganizationRestrictionScreeningStatus["UNSCREENED"] = "unscreened";
})(OrganizationRestrictionScreeningStatus = exports.OrganizationRestrictionScreeningStatus || (exports.OrganizationRestrictionScreeningStatus = {}));
var OutputStyle;
(function (OutputStyle) {
    OutputStyle["FLOW"] = "flow";
    OutputStyle["SHOPIFY_P_1"] = "shopify_p1";
})(OutputStyle = exports.OutputStyle || (exports.OutputStyle = {}));
var Owner;
(function (Owner) {
    Owner["FLOW"] = "flow";
    Owner["ORGANIZATION"] = "organization";
})(Owner = exports.Owner || (exports.Owner = {}));
var PaymentShortUrlDiscriminator;
(function (PaymentShortUrlDiscriminator) {
    PaymentShortUrlDiscriminator["ADYEN_3_DS_2"] = "adyen_3ds2";
})(PaymentShortUrlDiscriminator = exports.PaymentShortUrlDiscriminator || (exports.PaymentShortUrlDiscriminator = {}));
var PaymentSummaryStatus;
(function (PaymentSummaryStatus) {
    PaymentSummaryStatus["AUTHORIZED"] = "authorized";
    PaymentSummaryStatus["CANCELED"] = "canceled";
    PaymentSummaryStatus["DECLINED"] = "declined";
    PaymentSummaryStatus["EXPIRED"] = "expired";
    PaymentSummaryStatus["FAILED"] = "failed";
    PaymentSummaryStatus["PENDING"] = "pending";
    PaymentSummaryStatus["PROCESSED"] = "processed";
    PaymentSummaryStatus["REVERSED"] = "reversed";
    PaymentSummaryStatus["REVIEW"] = "review";
    PaymentSummaryStatus["SUCCEEDED"] = "succeeded";
})(PaymentSummaryStatus = exports.PaymentSummaryStatus || (exports.PaymentSummaryStatus = {}));
var PaymentSummaryType;
(function (PaymentSummaryType) {
    PaymentSummaryType["AUTHORIZATION"] = "authorization";
    PaymentSummaryType["CAPTURE"] = "capture";
    PaymentSummaryType["REFUND"] = "refund";
    PaymentSummaryType["REVERSAL"] = "reversal";
    PaymentSummaryType["CREDIT"] = "credit";
})(PaymentSummaryType = exports.PaymentSummaryType || (exports.PaymentSummaryType = {}));
var PaymentTerm;
(function (PaymentTerm) {
    PaymentTerm["NET_7"] = "net7";
    PaymentTerm["NET_15"] = "net15";
    PaymentTerm["NET_30"] = "net30";
})(PaymentTerm = exports.PaymentTerm || (exports.PaymentTerm = {}));
var PreferredBillingSchedule;
(function (PreferredBillingSchedule) {
    PreferredBillingSchedule["MONTHLY"] = "monthly";
    PreferredBillingSchedule["BI_MONTHLY"] = "bi-monthly";
})(PreferredBillingSchedule = exports.PreferredBillingSchedule || (exports.PreferredBillingSchedule = {}));
var PriceSelector;
(function (PriceSelector) {
    PriceSelector["MINIMUM"] = "minimum";
    PriceSelector["MAXIMUM"] = "maximum";
})(PriceSelector = exports.PriceSelector || (exports.PriceSelector = {}));
var ProcessingTransactionType;
(function (ProcessingTransactionType) {
    ProcessingTransactionType["ADJUSTMENT"] = "adjustment";
    ProcessingTransactionType["REVERSAL"] = "reversal";
    ProcessingTransactionType["CAPTURE"] = "capture";
    ProcessingTransactionType["REFUND"] = "refund";
    ProcessingTransactionType["FULLY_SUBSIDIZED_ORDER"] = "fully_subsidized_order";
    ProcessingTransactionType["CREDIT_PAYMENT"] = "credit_payment";
})(ProcessingTransactionType = exports.ProcessingTransactionType || (exports.ProcessingTransactionType = {}));
var Processor;
(function (Processor) {
    Processor["ADYEN"] = "adyen";
    Processor["AFTERPAY"] = "afterpay";
    Processor["BITPAY"] = "bitpay";
    Processor["STRIPE"] = "stripe";
    Processor["PAYPAL"] = "paypal";
    Processor["FLOW_SANDBOX"] = "flow_sandbox";
    Processor["FISERV"] = "fiserv";
    Processor["CRYPTO"] = "crypto";
})(Processor = exports.Processor || (exports.Processor = {}));
var ProcessorEntityStatus;
(function (ProcessorEntityStatus) {
    ProcessorEntityStatus["ACTIVE"] = "active";
    ProcessorEntityStatus["DRAFT"] = "draft";
    ProcessorEntityStatus["ARCHIVED"] = "archived";
})(ProcessorEntityStatus = exports.ProcessorEntityStatus || (exports.ProcessorEntityStatus = {}));
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["ACTIVE"] = "active";
    ProductStatus["ARCHIVED"] = "archived";
    ProductStatus["DRAFT"] = "draft";
})(ProductStatus = exports.ProductStatus || (exports.ProductStatus = {}));
var PromptAction;
(function (PromptAction) {
    PromptAction["PROMPT_DISPLAYED"] = "prompt_displayed";
    PromptAction["CONSENT_GRANTED"] = "consent_granted";
    PromptAction["CONSENT_DENIED"] = "consent_denied";
})(PromptAction = exports.PromptAction || (exports.PromptAction = {}));
var PromptCheckoutDisplayPosition;
(function (PromptCheckoutDisplayPosition) {
    PromptCheckoutDisplayPosition["EMAIL"] = "email";
    PromptCheckoutDisplayPosition["SUBMISSION"] = "submission";
})(PromptCheckoutDisplayPosition = exports.PromptCheckoutDisplayPosition || (exports.PromptCheckoutDisplayPosition = {}));
var PromptOptions;
(function (PromptOptions) {
    PromptOptions["NOTICE_ONLY"] = "notice_only";
    PromptOptions["REQUIRE_CONSENT"] = "require_consent";
    PromptOptions["CONSENT_BY_DEFAULT"] = "consent_by_default";
})(PromptOptions = exports.PromptOptions || (exports.PromptOptions = {}));
var PromptTarget;
(function (PromptTarget) {
    PromptTarget["BROWSE"] = "browse";
    PromptTarget["CHECKOUT"] = "checkout";
})(PromptTarget = exports.PromptTarget || (exports.PromptTarget = {}));
var QuoteRequestType;
(function (QuoteRequestType) {
    QuoteRequestType["GENERATE"] = "generate";
    QuoteRequestType["DELETE"] = "delete";
    QuoteRequestType["UPDATE_CURRENCY_RATE"] = "update_currency_rate";
    QuoteRequestType["UPDATE_COUNTRY"] = "update_country";
})(QuoteRequestType = exports.QuoteRequestType || (exports.QuoteRequestType = {}));
var RateLevelKey;
(function (RateLevelKey) {
    RateLevelKey["SHOPIFY_SMALL_USA"] = "shopify_small_usa";
    RateLevelKey["SHOPIFY_MEDIUM_USA"] = "shopify_medium_usa";
    RateLevelKey["SHOPIFY_ENTERPRISE_USA"] = "shopify_enterprise_usa";
    RateLevelKey["SHOPIFY_SMALL_SDC_USA"] = "shopify_small_sdc_usa";
})(RateLevelKey = exports.RateLevelKey || (exports.RateLevelKey = {}));
var RateSource;
(function (RateSource) {
    RateSource["CALCULATED"] = "calculated";
    RateSource["MARKET"] = "market";
})(RateSource = exports.RateSource || (exports.RateSource = {}));
var ReboundConfigurationStatus;
(function (ReboundConfigurationStatus) {
    ReboundConfigurationStatus["ACTIVE"] = "active";
    ReboundConfigurationStatus["INACTIVE"] = "inactive";
})(ReboundConfigurationStatus = exports.ReboundConfigurationStatus || (exports.ReboundConfigurationStatus = {}));
var RedirectReason;
(function (RedirectReason) {
    RedirectReason["THREE_D_SECURE"] = "three_d_secure";
})(RedirectReason = exports.RedirectReason || (exports.RedirectReason = {}));
var RejectionReason;
(function (RejectionReason) {
    RejectionReason["MERCHANT_POLICY"] = "merchant_policy";
    RejectionReason["PREVIOUS_CHARGEBACKS"] = "previous_chargebacks";
    RejectionReason["RESTRICTED_PARTY_SCREENING"] = "restricted_party_screening";
    RejectionReason["RISKY_VELOCITY"] = "risky_velocity";
    RejectionReason["SUSPICIOUS_BEHAVIOR"] = "suspicious_behavior";
    RejectionReason["SUSPICIOUS_PAST_ACTIVITY"] = "suspicious_past_activity";
})(RejectionReason = exports.RejectionReason || (exports.RejectionReason = {}));
var ReportInterval;
(function (ReportInterval) {
    ReportInterval["HOURLY"] = "hourly";
    ReportInterval["DAILY"] = "daily";
    ReportInterval["WEEKLY"] = "weekly";
    ReportInterval["MONTHLY"] = "monthly";
})(ReportInterval = exports.ReportInterval || (exports.ReportInterval = {}));
var ReportPaymentType;
(function (ReportPaymentType) {
    ReportPaymentType["CREDIT"] = "credit";
    ReportPaymentType["DEBIT"] = "debit";
})(ReportPaymentType = exports.ReportPaymentType || (exports.ReportPaymentType = {}));
var ReportStatus;
(function (ReportStatus) {
    ReportStatus["CREATED"] = "created";
    ReportStatus["COMPLETED"] = "completed";
    ReportStatus["COMPLETED_NO_RECORDS"] = "completed_no_records";
    ReportStatus["FAILED"] = "failed";
})(ReportStatus = exports.ReportStatus || (exports.ReportStatus = {}));
var ReportType;
(function (ReportType) {
    ReportType["SALES_RECORD"] = "sales_record";
    ReportType["REFUND_RECORD"] = "refund_record";
    ReportType["OTHER_RECORD"] = "other_record";
    ReportType["PENDING_RECORD"] = "pending_record";
    ReportType["TRUEUP_OVERVIEW"] = "trueup_overview";
    ReportType["NON_CHANNEL_PAYMENT_BANK_ACCOUNT"] = "non_channel_payment_bank_account";
    ReportType["SCHEDULED_PAYMENT"] = "scheduled_payment";
    ReportType["ACCOUNT_QUARTERLY_BALANCES"] = "account_quarterly_balances";
    ReportType["INVARIANTS"] = "invariants";
    ReportType["PAYMENTS"] = "payments";
    ReportType["RECONCILE_NOT_RECORDED"] = "reconcile_not_recorded";
    ReportType["PRODUCTS_RECORD"] = "products_record";
    ReportType["DISPUTES"] = "disputes";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
var ReportingFulfillmentIsVirtual;
(function (ReportingFulfillmentIsVirtual) {
    ReportingFulfillmentIsVirtual["ALL"] = "all";
    ReportingFulfillmentIsVirtual["MIXED"] = "mixed";
    ReportingFulfillmentIsVirtual["NONE"] = "none";
})(ReportingFulfillmentIsVirtual = exports.ReportingFulfillmentIsVirtual || (exports.ReportingFulfillmentIsVirtual = {}));
var ReportingScheme;
(function (ReportingScheme) {
    ReportingScheme["IMMEDIATE_REPORTING_TO_TAX_AUTHORITY"] = "immediate_reporting_to_tax_authority";
    ReportingScheme["PERIODIC_REPORTING_TO_TAX_AUTHORITY"] = "periodic_reporting_to_tax_authority";
    ReportingScheme["PAID_AT_BORDER"] = "paid_at_border";
    ReportingScheme["PAID_ON_DELIVERY"] = "paid_on_delivery";
})(ReportingScheme = exports.ReportingScheme || (exports.ReportingScheme = {}));
var ResponsibleParty;
(function (ResponsibleParty) {
    ResponsibleParty["FLOW"] = "flow";
    ResponsibleParty["ORGANIZATION"] = "organization";
})(ResponsibleParty = exports.ResponsibleParty || (exports.ResponsibleParty = {}));
var RestrictionAction;
(function (RestrictionAction) {
    RestrictionAction["PROHIBITED"] = "prohibited";
    RestrictionAction["RESTRICTED"] = "restricted";
})(RestrictionAction = exports.RestrictionAction || (exports.RestrictionAction = {}));
var RestrictionDecision;
(function (RestrictionDecision) {
    RestrictionDecision["ACCEPT"] = "accept";
    RestrictionDecision["ESCALATE"] = "escalate";
    RestrictionDecision["REJECT"] = "reject";
    RestrictionDecision["REVIEW"] = "review";
})(RestrictionDecision = exports.RestrictionDecision || (exports.RestrictionDecision = {}));
var RestrictionStatus;
(function (RestrictionStatus) {
    RestrictionStatus["PENDING"] = "pending";
    RestrictionStatus["IN_REVIEW"] = "in_review";
    RestrictionStatus["ESCALATED"] = "escalated";
    RestrictionStatus["ACCEPTED"] = "accepted";
    RestrictionStatus["RESTRICTED"] = "restricted";
})(RestrictionStatus = exports.RestrictionStatus || (exports.RestrictionStatus = {}));
var RevenueRecordType;
(function (RevenueRecordType) {
    RevenueRecordType["PENDING"] = "pending";
    RevenueRecordType["SALES"] = "sales";
    RevenueRecordType["REFUND"] = "refund";
})(RevenueRecordType = exports.RevenueRecordType || (exports.RevenueRecordType = {}));
var RiskCheck;
(function (RiskCheck) {
    RiskCheck["THREE_D_SECURE"] = "three_d_secure";
})(RiskCheck = exports.RiskCheck || (exports.RiskCheck = {}));
var RiskEvaluation;
(function (RiskEvaluation) {
    RiskEvaluation["PENDING"] = "Pending";
    RiskEvaluation["HIGH"] = "High-Risk";
    RiskEvaluation["LOW"] = "Low-Risk";
    RiskEvaluation["RESTRICTED"] = "Restricted-Party";
    RiskEvaluation["NONE"] = "none";
})(RiskEvaluation = exports.RiskEvaluation || (exports.RiskEvaluation = {}));
var SessionCountryStatus;
(function (SessionCountryStatus) {
    SessionCountryStatus["ENABLED"] = "enabled";
    SessionCountryStatus["DISABLED"] = "disabled";
})(SessionCountryStatus = exports.SessionCountryStatus || (exports.SessionCountryStatus = {}));
var ShopifyCheckInventoryErrorCode;
(function (ShopifyCheckInventoryErrorCode) {
    ShopifyCheckInventoryErrorCode["INVENTORY_OUT_OF_STOCK"] = "inventory_out_of_stock";
})(ShopifyCheckInventoryErrorCode = exports.ShopifyCheckInventoryErrorCode || (exports.ShopifyCheckInventoryErrorCode = {}));
var ShopifyGrantStatus;
(function (ShopifyGrantStatus) {
    ShopifyGrantStatus["PASS"] = "pass";
    ShopifyGrantStatus["FAIL"] = "fail";
})(ShopifyGrantStatus = exports.ShopifyGrantStatus || (exports.ShopifyGrantStatus = {}));
var ShopifyIncotermConfiguration;
(function (ShopifyIncotermConfiguration) {
    ShopifyIncotermConfiguration["DDP"] = "DDP";
    ShopifyIncotermConfiguration["DAP"] = "DAP";
    ShopifyIncotermConfiguration["DDU"] = "DDU";
    ShopifyIncotermConfiguration["UNSUPPORTED"] = "UNSUPPORTED";
})(ShopifyIncotermConfiguration = exports.ShopifyIncotermConfiguration || (exports.ShopifyIncotermConfiguration = {}));
var ShopifyMarketsDangerousGoods;
(function (ShopifyMarketsDangerousGoods) {
    ShopifyMarketsDangerousGoods["AEROSOLS"] = "aerosols";
    ShopifyMarketsDangerousGoods["AIR_BAG_INFLATORS_OR_SEAT_BELT_PRETENSIONERS"] = "air_bag_inflators_or_seat_belt_pretensioners";
    ShopifyMarketsDangerousGoods["ALCOHOLIC_BEVERAGES_CONTAINING_MORE_THAN_24_PERCENT_ALCOHOL_BY_VOLUME"] = "alcoholic_beverages_containing_more_than_24_percent_alcohol_by_volume";
    ShopifyMarketsDangerousGoods["BATTERIES"] = "batteries";
    ShopifyMarketsDangerousGoods["CARBON_DIOXIDE_OR_DRY_ICE"] = "carbon_dioxide_or_dry_ice";
    ShopifyMarketsDangerousGoods["CORROSIVES"] = "corrosives";
    ShopifyMarketsDangerousGoods["CANNABIDIOL_PRODUCTS"] = "cannabidiol_products";
    ShopifyMarketsDangerousGoods["COLOGNE_OR_PERFUME"] = "cologne_or_perfume";
    ShopifyMarketsDangerousGoods["CURRENCY_OR_GIFT_CARDS_OR_MONETARY_INSTRUMENTS"] = "currency_or_gift_cards_or_monetary_instruments";
    ShopifyMarketsDangerousGoods["EXOTIC_LEATHER_GOODS"] = "exotic_leather_goods";
    ShopifyMarketsDangerousGoods["ENVIRONMENTAL_WASTE"] = "environmental_waste";
    ShopifyMarketsDangerousGoods["EXPLOSIVES_OR_AMMUNITION"] = "explosives_or_ammunition";
    ShopifyMarketsDangerousGoods["FLAMMABLE_LIQUIDS"] = "flammable_liquids";
    ShopifyMarketsDangerousGoods["GASES"] = "gases";
    ShopifyMarketsDangerousGoods["HAZARDOUS_OR_COMBUSTIBLE_MATERIALS"] = "hazardous_or_combustible_materials";
    ShopifyMarketsDangerousGoods["INFECTIOUS_OR_BIOLOGICAL_SUBSTANCES"] = "infectious_or_biological_substances";
    ShopifyMarketsDangerousGoods["KNIVES"] = "knives";
    ShopifyMarketsDangerousGoods["MATCHES_OR_LIGHTER_OR_LIGHTER_REFILLS"] = "matches_or_lighter_or_lighter_refills";
    ShopifyMarketsDangerousGoods["NAIL_POLISH"] = "nail_polish";
    ShopifyMarketsDangerousGoods["OXIDIZING_MATERIALS_OR_ORGANIC_PEROXIDES"] = "oxidizing_materials_or_organic_peroxides";
    ShopifyMarketsDangerousGoods["PORNOGRAPHY"] = "pornography";
    ShopifyMarketsDangerousGoods["PROHIBITED_CARRIAGE"] = "prohibited_carriage";
    ShopifyMarketsDangerousGoods["PESTICIDES_OR_TOXIC_HERBICIDES_OR_INSECTICIDES_OR_POISONOUS_TOXIC_SUBSTANCES"] = "pesticides_or_toxic_herbicides_or_insecticides_or_poisonous_toxic_substances";
})(ShopifyMarketsDangerousGoods = exports.ShopifyMarketsDangerousGoods || (exports.ShopifyMarketsDangerousGoods = {}));
var ShopifyMarketsHtsNumberAvailable;
(function (ShopifyMarketsHtsNumberAvailable) {
    ShopifyMarketsHtsNumberAvailable["YES"] = "yes";
    ShopifyMarketsHtsNumberAvailable["NO"] = "no";
    ShopifyMarketsHtsNumberAvailable["I_DONT_KNOW"] = "i_dont_know";
})(ShopifyMarketsHtsNumberAvailable = exports.ShopifyMarketsHtsNumberAvailable || (exports.ShopifyMarketsHtsNumberAvailable = {}));
var ShopifyMarketsQueuedRecordType;
(function (ShopifyMarketsQueuedRecordType) {
    ShopifyMarketsQueuedRecordType["CARD_PAYMENT"] = "card_payment";
    ShopifyMarketsQueuedRecordType["CATALOG_PUBLICATION_SYNC"] = "catalog_publication_sync";
    ShopifyMarketsQueuedRecordType["FLOW_SHOP"] = "flow_shop";
    ShopifyMarketsQueuedRecordType["ONLINE_PAYMENT"] = "online_payment";
    ShopifyMarketsQueuedRecordType["ORDER_UPDATE"] = "order_update";
    ShopifyMarketsQueuedRecordType["ORDER_EDIT"] = "order_edit";
    ShopifyMarketsQueuedRecordType["PRODUCT_RESTRICTION_RESULT"] = "product_restriction_result";
    ShopifyMarketsQueuedRecordType["PRODUCT_SYNC"] = "product_sync";
    ShopifyMarketsQueuedRecordType["WEBHOOK_REGISTRATIONS"] = "webhook_registrations";
    ShopifyMarketsQueuedRecordType["CHANNEL_ORGANIZATION_IDENTIFIER"] = "channel_organization_identifier";
    ShopifyMarketsQueuedRecordType["BULK_PRODUCT_INGESTION"] = "bulk_product_ingestion";
    ShopifyMarketsQueuedRecordType["BULK_DUTY_UPDATE"] = "bulk_duty_update";
})(ShopifyMarketsQueuedRecordType = exports.ShopifyMarketsQueuedRecordType || (exports.ShopifyMarketsQueuedRecordType = {}));
var ShopifyMarketsTradeSector;
(function (ShopifyMarketsTradeSector) {
    ShopifyMarketsTradeSector["APPAREL_AND_ACCESSORIES"] = "apparel_and_accessories";
    ShopifyMarketsTradeSector["BEAUTY_AND_COSMETICS"] = "beauty_and_cosmetics";
    ShopifyMarketsTradeSector["ELECTRONICS"] = "electronics";
    ShopifyMarketsTradeSector["FOOD_OR_PERISHABLES"] = "food_or_perishables";
    ShopifyMarketsTradeSector["JEWELLERY_AND_WATCHES"] = "jewellery_and_watches";
    ShopifyMarketsTradeSector["PAPER_AND_ART"] = "paper_and_art";
    ShopifyMarketsTradeSector["SPORTS_AND_FITNESS"] = "sports_and_fitness";
    ShopifyMarketsTradeSector["TOYS_HOBBIES_GIFTS"] = "toys_hobbies_gifts";
    ShopifyMarketsTradeSector["OTHER"] = "other";
})(ShopifyMarketsTradeSector = exports.ShopifyMarketsTradeSector || (exports.ShopifyMarketsTradeSector = {}));
var ShopifyMonitoringMonitorReviewStatus;
(function (ShopifyMonitoringMonitorReviewStatus) {
    ShopifyMonitoringMonitorReviewStatus["IN_REVIEW"] = "in_review";
    ShopifyMonitoringMonitorReviewStatus["REVIEWED"] = "reviewed";
})(ShopifyMonitoringMonitorReviewStatus = exports.ShopifyMonitoringMonitorReviewStatus || (exports.ShopifyMonitoringMonitorReviewStatus = {}));
var ShopifyMonitoringTrackingField;
(function (ShopifyMonitoringTrackingField) {
    ShopifyMonitoringTrackingField["TRACKING_NUMBER"] = "tracking_number";
    ShopifyMonitoringTrackingField["CARRIER_SERVICE"] = "carrier_service";
    ShopifyMonitoringTrackingField["TRACKING_URL"] = "tracking_url";
})(ShopifyMonitoringTrackingField = exports.ShopifyMonitoringTrackingField || (exports.ShopifyMonitoringTrackingField = {}));
var ShopifyPromotionBehavior;
(function (ShopifyPromotionBehavior) {
    ShopifyPromotionBehavior["DISABLE_DISCOUNT_CODES"] = "disable_discount_codes";
})(ShopifyPromotionBehavior = exports.ShopifyPromotionBehavior || (exports.ShopifyPromotionBehavior = {}));
var ShopifyPromotionOfferAllocationMethod;
(function (ShopifyPromotionOfferAllocationMethod) {
    ShopifyPromotionOfferAllocationMethod["EACH"] = "each";
    ShopifyPromotionOfferAllocationMethod["ACROSS"] = "across";
})(ShopifyPromotionOfferAllocationMethod = exports.ShopifyPromotionOfferAllocationMethod || (exports.ShopifyPromotionOfferAllocationMethod = {}));
var ShopifyPromotionOrderEntitlementComponent;
(function (ShopifyPromotionOrderEntitlementComponent) {
    ShopifyPromotionOrderEntitlementComponent["SUBTOTAL"] = "subtotal";
    ShopifyPromotionOrderEntitlementComponent["SHIPPING"] = "shipping";
    ShopifyPromotionOrderEntitlementComponent["VAT"] = "vat";
    ShopifyPromotionOrderEntitlementComponent["DUTY"] = "duty";
})(ShopifyPromotionOrderEntitlementComponent = exports.ShopifyPromotionOrderEntitlementComponent || (exports.ShopifyPromotionOrderEntitlementComponent = {}));
var ShopifyPromotionStatus;
(function (ShopifyPromotionStatus) {
    ShopifyPromotionStatus["ACTIVE"] = "active";
    ShopifyPromotionStatus["INACTIVE"] = "inactive";
})(ShopifyPromotionStatus = exports.ShopifyPromotionStatus || (exports.ShopifyPromotionStatus = {}));
var ShopifyService;
(function (ShopifyService) {
    ShopifyService["PAYMENT"] = "payment";
    ShopifyService["DUTY_TAX_CALCULATOR"] = "duty_tax_calculator";
    ShopifyService["SELLABILITY"] = "sellability";
})(ShopifyService = exports.ShopifyService || (exports.ShopifyService = {}));
var SimpleRoundingStrategy;
(function (SimpleRoundingStrategy) {
    SimpleRoundingStrategy["NO_ROUNDING"] = "no_rounding";
    SimpleRoundingStrategy["CURRENCY_PRECISION"] = "currency_precision";
})(SimpleRoundingStrategy = exports.SimpleRoundingStrategy || (exports.SimpleRoundingStrategy = {}));
var SnoozeNextActionWith;
(function (SnoozeNextActionWith) {
    SnoozeNextActionWith["CUSTOMER_SERVICE"] = "customer_service";
    SnoozeNextActionWith["ENGINEERING"] = "engineering";
})(SnoozeNextActionWith = exports.SnoozeNextActionWith || (exports.SnoozeNextActionWith = {}));
var SnoozeSourceType;
(function (SnoozeSourceType) {
    SnoozeSourceType["TASK"] = "task";
    SnoozeSourceType["INVARIANT"] = "invariant";
})(SnoozeSourceType = exports.SnoozeSourceType || (exports.SnoozeSourceType = {}));
var SourceTypeFilter;
(function (SourceTypeFilter) {
    SourceTypeFilter["ORGANIZATION"] = "organization";
    SourceTypeFilter["CHANNEL"] = "channel";
})(SourceTypeFilter = exports.SourceTypeFilter || (exports.SourceTypeFilter = {}));
var StatementStatus;
(function (StatementStatus) {
    StatementStatus["CREATED"] = "created";
    StatementStatus["NO_TRANSACTIONS"] = "no_transactions";
    StatementStatus["TRANSACTIONS_ASSIGNED"] = "transactions_assigned";
    StatementStatus["STATEMENT_GENERATED"] = "statement_generated";
    StatementStatus["STATEMENT_REGENERATED"] = "statement_regenerated";
    StatementStatus["FAILED"] = "failed";
})(StatementStatus = exports.StatementStatus || (exports.StatementStatus = {}));
var StatementTransferTransactionLocation;
(function (StatementTransferTransactionLocation) {
    StatementTransferTransactionLocation["TRANSACTIONS_FILE"] = "transactions_file";
    StatementTransferTransactionLocation["SUMMARY"] = "summary";
})(StatementTransferTransactionLocation = exports.StatementTransferTransactionLocation || (exports.StatementTransferTransactionLocation = {}));
var StatisticType;
(function (StatisticType) {
    StatisticType["TIME_TO_CLASSIFY"] = "time-to-classify";
    StatisticType["TIME_TO_CLASSIFY_AGGREGATED"] = "time-to-classify-aggregated";
    StatisticType["RATE_SOURCE"] = "rate-source";
    StatisticType["RATE_FRESHNESS"] = "rate-freshness";
})(StatisticType = exports.StatisticType || (exports.StatisticType = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["YEARLY"] = "yearly";
    SubscriptionFrequency["MONTHLY"] = "monthly";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var SuggestionAction;
(function (SuggestionAction) {
    SuggestionAction["ACCEPT"] = "accept";
    SuggestionAction["VALIDATE"] = "validate";
    SuggestionAction["REVIEW"] = "review";
})(SuggestionAction = exports.SuggestionAction || (exports.SuggestionAction = {}));
var TariffEligibilityType;
(function (TariffEligibilityType) {
    TariffEligibilityType["REX"] = "rex";
})(TariffEligibilityType = exports.TariffEligibilityType || (exports.TariffEligibilityType = {}));
var TaskProcessorKey;
(function (TaskProcessorKey) {
    TaskProcessorKey["ORDER_MESSENGER"] = "order_messenger";
    TaskProcessorKey["HARMONIZATION"] = "harmonization";
    TaskProcessorKey["FRAUD_REVIEW"] = "fraud_review";
    TaskProcessorKey["CARRIER_ACCOUNT"] = "carrier_account";
    TaskProcessorKey["PAYMENT"] = "payment";
    TaskProcessorKey["RATE_LEVELS"] = "rate_levels";
    TaskProcessorKey["CENTER_DEFAULTS"] = "center_defaults";
})(TaskProcessorKey = exports.TaskProcessorKey || (exports.TaskProcessorKey = {}));
var TaxAndDutyInclusivitySetting;
(function (TaxAndDutyInclusivitySetting) {
    TaxAndDutyInclusivitySetting["DUTY_EXCLUSIVE_TAX_EXCLUSIVE"] = "duty_exclusive_tax_exclusive";
    TaxAndDutyInclusivitySetting["DUTY_INCLUSIVE_TAX_EXCLUSIVE"] = "duty_inclusive_tax_exclusive";
    TaxAndDutyInclusivitySetting["DUTY_EXCLUSIVE_TAX_INCLUSIVE"] = "duty_exclusive_tax_inclusive";
    TaxAndDutyInclusivitySetting["DUTY_INCLUSIVE_TAX_INCLUSIVE"] = "duty_inclusive_tax_inclusive";
})(TaxAndDutyInclusivitySetting = exports.TaxAndDutyInclusivitySetting || (exports.TaxAndDutyInclusivitySetting = {}));
var TaxCalculationErrorCode;
(function (TaxCalculationErrorCode) {
    TaxCalculationErrorCode["GENERIC_ERROR"] = "generic_error";
    TaxCalculationErrorCode["OUTSIDE_OF_JURISDICTION"] = "outside_of_jurisdiction";
})(TaxCalculationErrorCode = exports.TaxCalculationErrorCode || (exports.TaxCalculationErrorCode = {}));
var TaxParty;
(function (TaxParty) {
    TaxParty["CONSUMER"] = "consumer";
    TaxParty["ORGANIZATION"] = "organization";
    TaxParty["FLOW"] = "flow";
    TaxParty["CARRIER"] = "carrier";
})(TaxParty = exports.TaxParty || (exports.TaxParty = {}));
var TaxTransactionType;
(function (TaxTransactionType) {
    TaxTransactionType["ADJUSTMENT"] = "adjustment";
    TaxTransactionType["REVERSAL"] = "reversal";
    TaxTransactionType["TAX"] = "tax";
    TaxTransactionType["REFUND"] = "refund";
})(TaxTransactionType = exports.TaxTransactionType || (exports.TaxTransactionType = {}));
var TrackingIntegrationType;
(function (TrackingIntegrationType) {
    TrackingIntegrationType["API"] = "api";
    TrackingIntegrationType["BULK"] = "bulk";
    TrackingIntegrationType["AFTERSHIP"] = "aftership";
})(TrackingIntegrationType = exports.TrackingIntegrationType || (exports.TrackingIntegrationType = {}));
var TrackingLabelDimensionsSource;
(function (TrackingLabelDimensionsSource) {
    TrackingLabelDimensionsSource["AFTERSHIP"] = "aftership";
    TrackingLabelDimensionsSource["CARRIER_API"] = "carrier_api";
})(TrackingLabelDimensionsSource = exports.TrackingLabelDimensionsSource || (exports.TrackingLabelDimensionsSource = {}));
var TrackingProcessingFailureClassification;
(function (TrackingProcessingFailureClassification) {
    TrackingProcessingFailureClassification["TRACKING_EXPIRED"] = "tracking_expired";
    TrackingProcessingFailureClassification["EXPIRED_TRACKING_NUMBER_NEW_EVENT"] = "expired_tracking_number_new_event";
    TrackingProcessingFailureClassification["NEW_TRACKING_NUMBER_EXPIRED_EVENT"] = "new_tracking_number_expired_event";
    TrackingProcessingFailureClassification["ORIGIN_MISMATCH"] = "origin_mismatch";
    TrackingProcessingFailureClassification["DESTINATION_MISMATCH"] = "destination_mismatch";
    TrackingProcessingFailureClassification["OTHER"] = "other";
})(TrackingProcessingFailureClassification = exports.TrackingProcessingFailureClassification || (exports.TrackingProcessingFailureClassification = {}));
var TransactionPostingMethod;
(function (TransactionPostingMethod) {
    TransactionPostingMethod["TIME"] = "time";
    TransactionPostingMethod["PROOF"] = "proof";
})(TransactionPostingMethod = exports.TransactionPostingMethod || (exports.TransactionPostingMethod = {}));
var TransferMethod;
(function (TransferMethod) {
    TransferMethod["ACH"] = "ach";
})(TransferMethod = exports.TransferMethod || (exports.TransferMethod = {}));
var TrueupTransactionType;
(function (TrueupTransactionType) {
    TrueupTransactionType["ADJUSTMENT"] = "adjustment";
    TrueupTransactionType["REVERSAL"] = "reversal";
    TrueupTransactionType["TRUEUP"] = "trueup";
})(TrueupTransactionType = exports.TrueupTransactionType || (exports.TrueupTransactionType = {}));
var UnclassifiedProductStatus;
(function (UnclassifiedProductStatus) {
    UnclassifiedProductStatus["IGNORED"] = "ignored";
    UnclassifiedProductStatus["ESCALATED"] = "escalated";
    UnclassifiedProductStatus["REQUEUED"] = "requeued";
    UnclassifiedProductStatus["UNVERIFIED"] = "unverified";
    UnclassifiedProductStatus["QUEUED"] = "queued";
    UnclassifiedProductStatus["UNCONFIDENT"] = "unconfident";
})(UnclassifiedProductStatus = exports.UnclassifiedProductStatus || (exports.UnclassifiedProductStatus = {}));
